/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} shoutoutPreviewSwitchViewCtaParams
* @property {string} context - application context
* @property {string} ml_translation_language - the language
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_name - package - vendor product id
* @property {string} package_id - null
* @property {GUID} uuid - user id
* @property {string} view - mobile/web
**/
/**
 * Name: shoutout preview - switch view cta. Evid: 23.
 * Event description: when user in email preview switches from desktop view to mobile and vice versa.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string. Desc: the language
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_name - Type: string. Desc: package - vendor product id
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: mobile/web
 * @param {shoutoutPreviewSwitchViewCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPreviewSwitchViewCta = function (params) {
    return { evid: 23, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutEmailVerificationClickConfirmSendCodeParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {boolean} resend - resend
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout email verification-> click confirm send code. Evid: 153.
 * Event description: Sending confirmation code - clicking on confirm in lightbox - to confirm the system to send the confirmation code.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * resend - Type: bool. Desc: resend
 *
 * uuid - Type: guid.
 * @param {shoutoutEmailVerificationClickConfirmSendCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutEmailVerificationClickConfirmSendCode = function (params) {
    return { evid: 153, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emPurchasePremiumPlanParams
* @property {string} button_location - where was the button that lead to PP (source comes from 36:377)
* @property {string} button_name - button name that lead to PP (source comes from 36:377)
* @property {string} context - null
* @property {string} cycleName - selected EM premium package cycle
* @property {string} em_premium_status - current EM premium package + cycle
* @property {boolean} is_mailbox_promo - true if user was shown the mailbox promo
* @property {boolean} is_sale - Flag that defines if the users PP is with a sale
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - where the page was opened from (source comes from 36:377)
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} package_name - selected EM package name
* @property {GUID} uuid - null
**/
/**
 * Name: EM - Purchase Premium Plan. Evid: 382.
 * Event description: EM Premium Plan Purchased (Thank you page shown).

 * button_location - Type: string. Desc: where was the button that lead to PP (source comes from 36:377)
 *
 * button_name - Type: string. Desc: button name that lead to PP (source comes from 36:377)
 *
 * context - Type: string.
 *
 * cycleName - Type: string. Desc: selected EM premium package cycle
 *
 * em_premium_status - Type: string. Desc: current EM premium package + cycle
 *
 * is_mailbox_promo - Type: bool. Desc: true if user was shown the mailbox promo
 *
 * is_sale - Type: bool. Desc: Flag that defines if the users PP is with a sale
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: where the page was opened from (source comes from 36:377)
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * package_name - Type: string. Desc: selected EM package name
 *
 * uuid - Type: guid.
 * @param {emPurchasePremiumPlanParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emPurchasePremiumPlan = function (params) {
    return { evid: 382, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teBannerViewParams
* @property {string} banner_name - name of the banner
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - metasite id
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: TE - banner view. Evid: 354.


 * banner_name - Type: string. Desc: name of the banner
 *
 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: metasite id
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {teBannerViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teBannerView = function (params) {
    return { evid: 354, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} tipsLightboxCtaClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: tips lightbox CTA click. Evid: 117.
 * Event description: event is triggered when the user is clicking on "confirm" in the lightbox in shoutout contacts page, giving qty limitation for the number of contacts..

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {tipsLightboxCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tipsLightboxCtaClick = function (params) {
    return { evid: 117, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeItemDuplicateClickParams
* @property {string} context - context
* @property {boolean} is_title - is title region
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_name - package_name
* @property {string} package_id - null
* @property {string} type - the type of the item(text,rsvp,music,button, etc....)
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout compose -> item duplicate click. Evid: 307.
 * Event description: when the user clicks on duplicate on an item on stage in the composer.

 * context - Type: string. Desc: context
 *
 * is_title - Type: bool. Desc: is title region
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_name - Type: string. Desc: package_name
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: the type of the item(text,rsvp,music,button, etc....)
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutComposeItemDuplicateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeItemDuplicateClick = function (params) {
    return { evid: 307, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWellDoneReuseParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout well done -> reuse. Evid: 54.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWellDoneReuseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWellDoneReuse = function (params) {
    return { evid: 54, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teTextComponentDynamicVariableModalCancelParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - text-region/subject
* @property {GUID} uuid - null
**/
/**
 * Name: TE - text component dynamic variable modal cancel. Evid: 244.
 * Event description: cancel to close the dynamic variable.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: text-region/subject
 *
 * uuid - Type: guid.
 * @param {teTextComponentDynamicVariableModalCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teTextComponentDynamicVariableModalCancel = function (params) {
    return { evid: 244, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostPreviewAdChangeImageClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost preview -> ad change image click. Evid: 182.
 * Event description: clicking on change image button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostPreviewAdChangeImageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostPreviewAdChangeImageClick = function (params) {
    return { evid: 182, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutTemplatesPreviewClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - dashboard/template page
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} page_id - na
* @property {string} template_name - na
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout templates -> preview click. Evid: 63.
 * Event description: templates - previewing a template.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: dashboard/template page
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: guid. Desc: na
 *
 * template_name - Type: string. Desc: na
 *
 * uuid - Type: guid.
 * @param {shoutoutTemplatesPreviewClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutTemplatesPreviewClick = function (params) {
    return { evid: 63, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} firstTimeExperiencePageViewParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {number} no_of_subscribers - number of subscribers user has
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - source from where the users open the composer
* @property {string} template_ids - list of template ids shown to user
* @property {GUID} template_list_id - shown template list id
* @property {string} template_names - list of template names shown to user
* @property {GUID} uuid - null
**/
/**
 * Name: first time experience - page view. Evid: 311.
 * Event description: first time experience page been loaded.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * no_of_subscribers - Type: numeric. Desc: number of subscribers user has
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: source from where the users open the composer
 *
 * template_ids - Type: string. Desc: list of template ids shown to user
 *
 * template_list_id - Type: guid. Desc: shown template list id
 *
 * template_names - Type: string. Desc: list of template names shown to user
 *
 * uuid - Type: guid.
 * @param {firstTimeExperiencePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstTimeExperiencePageView = function (params) {
    return { evid: 311, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposerExitCtaParams
* @property {string} button_name - null
* @property {string} context - context
* @property {string} exitType - where the user is exiting to
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout composer - exit cta. Evid: 356.
 * Event description: When the user clicks back out of composer.

 * button_name - Type: string.
 *
 * context - Type: string. Desc: context
 *
 * exitType - Type: string. Desc: where the user is exiting to
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposerExitCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposerExitCta = function (params) {
    return { evid: 356, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutEmailVerificationCodeNotCorrectParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout email verification-> code not correct. Evid: 152.
 * Event description: Entering wrong confirmation code, click confirm and get warning message.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutEmailVerificationCodeNotCorrectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutEmailVerificationCodeNotCorrect = function (params) {
    return { evid: 152, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsActiveContactsButtonClickParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {boolean} only_active - true = only actives
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {GUID} page_id - page_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout contacts -> active contacts button click. Evid: 226.
 * Event description: click on the active contacts button to turn off/on the 'only active status'.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * only_active - Type: bool. Desc: true = only actives
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * page_id - Type: guid. Desc: page_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutContactsActiveContactsButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsActiveContactsButtonClick = function (params) {
    return { evid: 226, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageMessageSentParams
* @property {boolean} ad_state - true if campaign was sent with EM Ad
* @property {string} additional_features - list of interesting features we want to check if users used
* @property {string} context -
* @property {string} font - title font
* @property {number} hour_difference - the time difference of the user time zone and the utc (gmt)
* @property {boolean} is_resend - was action performed in resend to non-openers flow
* @property {GUID} message_id - guid
* @property {string} ml_translation_language - null
* @property {GUID} msid -
* @property {boolean} only_active - true = only actives
* @property {string} package_group -
* @property {string} package_id -
* @property {DateTime} quota_period_start - the date the quota period start
* @property {string} region_types - region_types / not sent in the case of resend
* @property {string} schedule_type - "regular-send-now" / "scheduled" / "scheduled-send-now"
* @property {DateTime} set_time - the time the shoutout was set  UTC (when will it be sent)
* @property {string} skin - skin name
* @property {string} template_id - id of the template
* @property {string} template_list_name - list name(BO) || top/bottom
* @property {string} template_name - template name
* @property {number} update_quota - the new quota for the user (for unlimited value is 99999)
* @property {GUID} uuid -
**/
/**
 * Name: shoutout send page -> message sent. Evid: 50.


 * ad_state - Type: bool. Desc: true if campaign was sent with EM Ad
 *
 * additional_features - Type: string. Desc: list of interesting features we want to check if users used
 *
 * context - Type: string.
 *
 * font - Type: string. Desc: title font
 *
 * hour_difference - Type: numeric. Desc: the time difference of the user time zone and the utc (gmt)
 *
 * is_resend - Type: bool. Desc: was action performed in resend to non-openers flow
 *
 * message_id - Type: guid. Desc: guid
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * only_active - Type: bool. Desc: true = only actives
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * quota_period_start - Type: datetime. Desc: the date the quota period start
 *
 * region_types - Type: string. Desc: region_types / not sent in the case of resend
 *
 * schedule_type - Type: string. Desc: "regular-send-now" / "scheduled" / "scheduled-send-now"
 *
 * set_time - Type: datetime. Desc: the time the shoutout was set  UTC (when will it be sent)
 *
 * skin - Type: string. Desc: skin name
 *
 * template_id - Type: string. Desc: id of the template
 *
 * template_list_name - Type: string. Desc: list name(BO) || top/bottom
 *
 * template_name - Type: string. Desc: template name
 *
 * update_quota - Type: numeric. Desc: the new quota for the user (for unlimited value is 99999)
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageMessageSentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageMessageSent = function (params) {
    return { evid: 50, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSelectCancelClickParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout select -> cancel click. Evid: 35.
 * Event description: SO_SELECT_CANCEL_CLICK.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {shoutoutSelectCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSelectCancelClick = function (params) {
    return { evid: 35, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostPaymentRefreshClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost payment -> refresh_click. Evid: 191.
 * Event description: getting back to payment page after editing in fb.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostPaymentRefreshClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostPaymentRefreshClick = function (params) {
    return { evid: 191, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teComposerAddDynamicVariableParams
* @property {string} component - Subject line/preview text
* @property {string} context - context (TE/APeS...)
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {string} template_id - template id
* @property {string} type - Subject and preview
* @property {GUID} uuid - null
* @property {string} variable_added - variable added(sites_name...))
**/
/**
 * Name: TE - composer add dynamic variable. Evid: 340.
 * Event description: add dynamic variable.

 * component - Type: string. Desc: Subject line/preview text
 *
 * context - Type: string. Desc: context (TE/APeS...)
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * template_id - Type: string. Desc: template id
 *
 * type - Type: string. Desc: Subject and preview
 *
 * uuid - Type: guid.
 *
 * variable_added - Type: string. Desc: variable added(sites_name...))
 * @param {teComposerAddDynamicVariableParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teComposerAddDynamicVariable = function (params) {
    return { evid: 340, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsLearnMoreClickParams
* @property {string} context - context
* @property {string} link_name - the name of the link to the learn more artical
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats-> learn more click. Evid: 320.
 * Event description: when the user clickes on one of the learn more options.

 * context - Type: string. Desc: context
 *
 * link_name - Type: string. Desc: the name of the link to the learn more artical
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page_status - Type: string. Desc: "the status of the page, if empty or not optional values: empty_state/full_data"
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsLearnMoreClick = function (params) {
    return { evid: 320, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teComposerModalClickParams
* @property {string} context - context (TE/APeS...)
* @property {string} cta_type - reset/cancel/dismiss
* @property {string} ml_translation_language - null
* @property {string} modal_name - name of the modal(example: Reset template)
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE -  composer modal click. Evid: 342.
 * Event description: generic modal click in the composer.

 * context - Type: string. Desc: context (TE/APeS...)
 *
 * cta_type - Type: string. Desc: reset/cancel/dismiss
 *
 * ml_translation_language - Type: string.
 *
 * modal_name - Type: string. Desc: name of the modal(example: Reset template)
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teComposerModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teComposerModalClick = function (params) {
    return { evid: 342, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsContactPageInfoLoadedParams
* @property {number} contacts_count - number of contacts loaded
* @property {string} context - context
* @property {number} filters_count - number of filters loaded
* @property {number} labels_count - number of label loaded
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {boolean} only_active - true = only actives
* @property {string} package_group - null
* @property {string} package_id - null
* @property {number} ready_segments_count - Segments, which are available for selection count
* @property {number} total_segments_count - Total segments count (ready for selection and not ready for selection (procesing etc.)
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout - contacts > contact_page_info_loaded. Evid: 321.
 * Event description: after contacts page is open (event 36:20), and then load the full contacts label and filter lists this event will be fired contain all this data.

 * contacts_count - Type: numeric. Desc: number of contacts loaded
 *
 * context - Type: string. Desc: context
 *
 * filters_count - Type: numeric. Desc: number of filters loaded
 *
 * labels_count - Type: numeric. Desc: number of label loaded
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * only_active - Type: bool. Desc: true = only actives
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * ready_segments_count - Type: numeric. Desc: Segments, which are available for selection count
 *
 * total_segments_count - Type: numeric. Desc: Total segments count (ready for selection and not ready for selection (procesing etc.)
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutContactsContactPageInfoLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsContactPageInfoLoaded = function (params) {
    return { evid: 321, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerAssistanceCompleteAllTasksSucessDoneClickParams
* @property {string} context - context
* @property {string} cta_type - cta name
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer - assistance complete all tasks sucess done click. Evid: 332.
 * Event description: user completed all tasks and got the success view - click on got it cta.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: cta name
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerAssistanceCompleteAllTasksSucessDoneClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerAssistanceCompleteAllTasksSucessDoneClick = function (params) {
    return { evid: 332, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shotuoutComplianceReasonToolTipParams
* @property {string} compliance_status - Warned / suspended / banned (from server)
* @property {string} context -
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group -
* @property {string} package_id -
* @property {string} page_name - from which page of the compliance
* @property {string} reason - Spam_complaints / spam_traps / bounces / low_engagement / vetting - from server
* @property {string} reason_tooltip - which of the info: Spam_complaints / spam_traps / bounces / low_engagement
* @property {GUID} uuid -
**/
/**
 * Name: shotuout compliance - reason tool tip. Evid: 92.
 * Event description: in the compliance page - over on info icon.

 * compliance_status - Type: string. Desc: Warned / suspended / banned (from server)
 *
 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_name - Type: string. Desc: from which page of the compliance
 *
 * reason - Type: string. Desc: Spam_complaints / spam_traps / bounces / low_engagement / vetting - from server
 *
 * reason_tooltip - Type: string. Desc: which of the info: Spam_complaints / spam_traps / bounces / low_engagement
 *
 * uuid - Type: guid.
 * @param {shotuoutComplianceReasonToolTipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shotuoutComplianceReasonToolTip = function (params) {
    return { evid: 92, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPackagePickerRadioButtonParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: Shoutout package picker -> radio button. Evid: 18.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutPackagePickerRadioButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPackagePickerRadioButton = function (params) {
    return { evid: 18, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutLinkComponentInfoParams
* @property {string} context - context
* @property {boolean} is_successful - true / false
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - package_name
* @property {string} source - wix / embedly
* @property {string} url - url
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout - link component info. Evid: 369.
 * Event description: when the user clicks on "apply" after adding link component.

 * context - Type: string. Desc: context
 *
 * is_successful - Type: bool. Desc: true / false
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string. Desc: package_name
 *
 * source - Type: string. Desc: wix / embedly
 *
 * url - Type: string. Desc: url
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutLinkComponentInfoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutLinkComponentInfo = function (params) {
    return { evid: 369, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutEmailVerificationSuccessViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout email verification-> success view. Evid: 156.
 * Event description: Verification successful view open after click confirm with  correct code.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutEmailVerificationSuccessViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutEmailVerificationSuccessView = function (params) {
    return { evid: 156, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} notInUseGetSubscribersSubscribeClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: NOT IN USE - get subscribers -> subscribe click. Evid: 198.
 * Event description: when users or user clicked "subscribe".

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {notInUseGetSubscribersSubscribeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notInUseGetSubscribersSubscribeClick = function (params) {
    return { evid: 198, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersSubscribeSuccessParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers -> subscribe success. Evid: 301.
 * Event description: when getting confirm from the server after clicking on "subscribe".

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {getSubscribersSubscribeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersSubscribeSuccess = function (params) {
    return { evid: 301, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutDuplicateMessageClickParams
* @property {string} context - null
* @property {GUID} message_id - message id
* @property {string} messages_type - draft/published
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout my shoutout -> duplicate message click. Evid: 129.
 * Event description: in my shoutout , on one of the SO items click on "duplicate message".

 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message id
 *
 * messages_type - Type: string. Desc: draft/published
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutMyShoutoutDuplicateMessageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutDuplicateMessageClick = function (params) {
    return { evid: 129, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostCongratsPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost congrats-> page view. Evid: 194.
 * Event description: page view.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostCongratsPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostCongratsPageView = function (params) {
    return { evid: 194, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shotuoutCompliancePageViewParams
* @property {string} compliance_status - Warned / suspended / banned (from server)
* @property {string} context -
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group -
* @property {string} package_id -
* @property {string} page_name - from which page of the compliance: Warning / Get_in_touch / message_submitted / suspended / questionnaire / questionnaire_submitted / case_process_qustionnaire / banned / case_process_banned
* @property {string} reason - coma separated reasons
* @property {GUID} uuid -
**/
/**
 * Name: shotuout compliance - page view. Evid: 93.
 * Event description: page view loaded for user.

 * compliance_status - Type: string. Desc: Warned / suspended / banned (from server)
 *
 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_name - Type: string. Desc: from which page of the compliance: Warning / Get_in_touch / message_submitted / suspended / questionnaire / questionnaire_submitted / case_process_qustionnaire / banned / case_process_banned
 *
 * reason - Type: string. Desc: coma separated reasons
 *
 * uuid - Type: guid.
 * @param {shotuoutCompliancePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shotuoutCompliancePageView = function (params) {
    return { evid: 93, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWebPageLandingSubscriptionClickParams
* @property {string} context - null
* @property {string} email - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} pageId - null
* @property {string} page_id - message identifier
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout web page -> landing subscription click. Evid: 164.
 * Event description: on the shoutout web page that UoU gets, he clicks on subscription button.

 * context - Type: string.
 *
 * email - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * pageId - Type: string.
 *
 * page_id - Type: string. Desc: message identifier
 *
 * uuid - Type: guid.
 * @param {shoutoutWebPageLandingSubscriptionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWebPageLandingSubscriptionClick = function (params) {
    return { evid: 164, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutLpPageView261Params
* @property {string} context - context - TE
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout lp -> view lp click. Evid: 261.
 * Event description: on click of the "shoutout my shoutout -> view lp click".

 * context - Type: string. Desc: context - TE
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutLpPageView261Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutLpPageView261 = function (params) {
    return { evid: 261, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerAssistanceTaskCompleteParams
* @property {string} assist_stat - open/closed
* @property {string} context - context
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} rule - unique rule id
* @property {string} task_type - text, button, link, social....
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer - assistance task complete. Evid: 329.
 * Event description: user completed a task and it marked as completed.

 * assist_stat - Type: string. Desc: open/closed
 *
 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * rule - Type: string. Desc: unique rule id
 *
 * task_type - Type: string. Desc: text, button, link, social....
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerAssistanceTaskCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerAssistanceTaskComplete = function (params) {
    return { evid: 329, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSendToUnsubscribedCheckboxCtaParams
* @property {string} context - context
* @property {string} cta_type - check / uncheck
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: TE - send to unsubscribed checkbox cta. Evid: 372.
 * Event description: When a user checks or unchecks the checkbox for sending automated email to unsubscribed users.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: check / uncheck
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {teSendToUnsubscribedCheckboxCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSendToUnsubscribedCheckboxCta = function (params) {
    return { evid: 372, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageSendButtonParams
* @property {string} context - null
* @property {number} count - null
* @property {boolean} is_resend - was action performed in resend to non-openers flow
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page -> send button. Evid: 33.


 * context - Type: string.
 *
 * count - Type: numeric.
 *
 * is_resend - Type: bool. Desc: was action performed in resend to non-openers flow
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageSendButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageSendButton = function (params) {
    return { evid: 33, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeOnStageItemCropClickParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - itme type
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> on stage item crop click. Evid: 334.
 * Event description: on stage, click on crop action on an item, and actually changed the value.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: itme type
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeOnStageItemCropClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeOnStageItemCropClick = function (params) {
    return { evid: 334, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} domainAuthenticationCtaClickParams
* @property {string} context - context
* @property {string} cta_type - view_dns_records, authenticate, close, done, need_guidance, learn_why, copy_host/points_cnameX
* @property {string} domain_authentication_status - authenticated / not authenticated
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: domain authentication CTA click. Evid: 361.
 * Event description: When user clicks on one of the CTAs associated with domain authentication.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: view_dns_records, authenticate, close, done, need_guidance, learn_why, copy_host/points_cnameX
 *
 * domain_authentication_status - Type: string. Desc: authenticated / not authenticated
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {domainAuthenticationCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var domainAuthenticationCtaClick = function (params) {
    return { evid: 361, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageNameFocusParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page -> name focus. Evid: 31.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageNameFocusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageNameFocus = function (params) {
    return { evid: 31, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerAssistanceWelcomePopoverViewParams
* @property {string} context - context
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer - assistance welcome  popover view. Evid: 325.
 * Event description: welcome assistance popover is opened.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerAssistanceWelcomePopoverViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerAssistanceWelcomePopoverView = function (params) {
    return { evid: 325, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsActiveContactToolTipHoverParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {GUID} page_id - page_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout contacts -> active contact tool tip hover. Evid: 227.
 * Event description: active contact tool tip hover - opens tool tip view.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * page_id - Type: guid. Desc: page_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutContactsActiveContactToolTipHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsActiveContactToolTipHover = function (params) {
    return { evid: 227, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWellDoneWhatNextMyShoutoutsClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout well done -> what next MyShoutouts click. Evid: 26.
 * Event description: COMPLETE_PAGE_WHATS_NEXT_MY_SHOUTOUTS_CLICK.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWellDoneWhatNextMyShoutoutsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWellDoneWhatNextMyShoutoutsClick = function (params) {
    return { evid: 26, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutVideoVideoCloseClickParams
* @property {string} click_location - either its on 'X' or CTA button
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout video -> video close click. Evid: 88.
 * Event description: When user clicking 'X' or CTA button on video widget.

 * click_location - Type: string. Desc: either its on 'X' or CTA button
 *
 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutVideoVideoCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutVideoVideoCloseClick = function (params) {
    return { evid: 88, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutHistoryReuseClickParams
* @property {string} context - null
* @property {GUID} message_id - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout history -> reuse click. Evid: 62.


 * context - Type: string.
 *
 * message_id - Type: guid.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutHistoryReuseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutHistoryReuseClick = function (params) {
    return { evid: 62, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPreviewPageTestMailClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout preview page -> test mail click. Evid: 137.
 * Event description: in the shoutout preview page click on "send test mail" button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutPreviewPageTestMailClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPreviewPageTestMailClick = function (params) {
    return { evid: 137, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutBannedResolveClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout banned -> resolve click. Evid: 168.
 * Event description: when user get suspended account view when entering shoutout and click on the "resolve" button - take him to ticket system....

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutBannedResolveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutBannedResolveClick = function (params) {
    return { evid: 168, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSelectUseThisClickParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout select -> use this click. Evid: 36.
 * Event description: SO_SELECT_USE_THIS_CLICK.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {shoutoutSelectUseThisClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSelectUseThisClick = function (params) {
    return { evid: 36, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} htmlComponentCodePastedParams
* @property {number} char_diff - Pasted char count
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: HTML Component Code Pasted. Evid: 375.
 * Event description: HTML component code batch pasted.

 * char_diff - Type: numeric. Desc: Pasted char count
 *
 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {htmlComponentCodePastedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var htmlComponentCodePasted = function (params) {
    return { evid: 375, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardShoutoutReuseParams
* @property {string} context - null
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout dashboard->shoutout reuse. Evid: 78.
 * Event description: new shoutout clicked.

 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutDashboardShoutoutReuseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardShoutoutReuse = function (params) {
    return { evid: 78, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageModalViewParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {string} modal_type - error
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout send page -> modal view. Evid: 293.
 * Event description: when a modal is open in the send page (error).

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: error
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutSendPageModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageModalView = function (params) {
    return { evid: 293, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutHtmlIntroductionModalCloseParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - "got it", "xButton"
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout html -> introduction modal close. Evid: 279.
 * Event description: closed the modal by got it or by pressing on X.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: "got it", "xButton"
 *
 * uuid - Type: guid.
 * @param {shoutoutHtmlIntroductionModalCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutHtmlIntroductionModalClose = function (params) {
    return { evid: 279, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} oneAppPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page_loaded - distinguish between My Shoutouts or Templates page loading
* @property {GUID} uuid - null
**/
/**
 * Name: one app - page view. Evid: 206.
 * Event description: distinguish between My Shoutouts or Templates page loading.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_loaded - Type: string. Desc: distinguish between My Shoutouts or Templates page loading
 *
 * uuid - Type: guid.
 * @param {oneAppPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oneAppPageView = function (params) {
    return { evid: 206, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersSettingsFormFieldNameSwitchParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {boolean} status - true:On, false:Off
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers settings - form field name switch. Evid: 214.
 * Event description: Choosing whether to display name field.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * status - Type: bool. Desc: true:On, false:Off
 *
 * uuid - Type: guid.
 * @param {getSubscribersSettingsFormFieldNameSwitchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersSettingsFormFieldNameSwitch = function (params) {
    return { evid: 214, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageScheduleButtonParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout send page -> schedule button. Evid: 292.
 * Event description: click on schedule in the send page.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutSendPageScheduleButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageScheduleButton = function (params) {
    return { evid: 292, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} smartTriggersCustomizePreviewClickParams
* @property {string} context - application context
* @property {string} location - hover/button
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: smart triggers customize -> preview click. Evid: 49.
 * Event description: ST_CUSTOMIZE_PREVIEW_CLICK.

 * context - Type: string. Desc: application context
 *
 * location - Type: string. Desc: hover/button
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {smartTriggersCustomizePreviewClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartTriggersCustomizePreviewClick = function (params) {
    return { evid: 49, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutQuotaChangeModalViewParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout -> quota change modal view. Evid: 370.
 * Event description: when user sees quota change modal.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutQuotaChangeModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutQuotaChangeModalView = function (params) {
    return { evid: 370, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposerModalCtaClickParams
* @property {string} context - context
* @property {string} cta_type - send, pause, cancel
* @property {string} message_id - if exists
* @property {string} ml_translation_language - null
* @property {string} modal_type - the type of the modal (send, pause)
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout composer -> modal cta click. Evid: 306.
 * Event description: any modal that is been opened in the composer page, click on one of the CTAs in side the modal.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: send, pause, cancel
 *
 * message_id - Type: string. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: the type of the modal (send, pause)
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutComposerModalCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposerModalCtaClick = function (params) {
    return { evid: 306, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsActiveContactToolTipMessageViewParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {GUID} page_id - page_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout contacts ->  active contact tool tip message view. Evid: 231.
 * Event description: when switch off the active contacts- a tool tip message is been shown.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * page_id - Type: guid. Desc: page_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutContactsActiveContactToolTipMessageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsActiveContactToolTipMessageView = function (params) {
    return { evid: 231, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWellDoneClickOnLinkParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout well done -> click on link. Evid: 52.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWellDoneClickOnLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWellDoneClickOnLink = function (params) {
    return { evid: 52, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutCompleteDialogDoneViewParams
* @property {string} context - null
* @property {boolean} is_resend - was action performed in resend to non-openers flow
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout complete dialog done->  view. Evid: 166.
 * Event description: Viewing completion dialog.

 * context - Type: string.
 *
 * is_resend - Type: bool. Desc: was action performed in resend to non-openers flow
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutCompleteDialogDoneViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutCompleteDialogDoneView = function (params) {
    return { evid: 166, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emPackagePickerCyclePageParams
* @property {string} button_location - where was the button that lead to PP (source comes from 36:377)
* @property {string} button_name - button name that lead to PP (source comes from 36:377)
* @property {string} context - null
* @property {string} em_premium_status - current EM premium package + cycle
* @property {boolean} is_sale - Flag that defines if the users PP is with a sale
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - where the page was opened from (source comes from 36:377)
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} package_name - selected EM package name
* @property {GUID} uuid - null
**/
/**
 * Name: EM - Package Picker Cycle Page. Evid: 380.
 * Event description: EM Package Picker Cycle Page Opened (page shown).

 * button_location - Type: string. Desc: where was the button that lead to PP (source comes from 36:377)
 *
 * button_name - Type: string. Desc: button name that lead to PP (source comes from 36:377)
 *
 * context - Type: string.
 *
 * em_premium_status - Type: string. Desc: current EM premium package + cycle
 *
 * is_sale - Type: bool. Desc: Flag that defines if the users PP is with a sale
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: where the page was opened from (source comes from 36:377)
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * package_name - Type: string. Desc: selected EM package name
 *
 * uuid - Type: guid.
 * @param {emPackagePickerCyclePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emPackagePickerCyclePage = function (params) {
    return { evid: 380, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostCongratsPostClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost congrats-> post click. Evid: 196.
 * Event description: clicking on post to facebook.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostCongratsPostClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostCongratsPostClick = function (params) {
    return { evid: 196, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teAutoAutomationsWidgetCtaClickParams
* @property {GUID} action_id - action_id
* @property {string} context - context
* @property {string} cta_type - edit,preview
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} rule_id - rule_id
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE -template widget CTA click. Evid: 272.
 * Event description: click on a cta in the template widget.

 * action_id - Type: guid. Desc: action_id
 *
 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: edit,preview
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * rule_id - Type: guid. Desc: rule_id
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teAutoAutomationsWidgetCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teAutoAutomationsWidgetCtaClick = function (params) {
    return { evid: 272, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutOpenInitiatedParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout-> open initiated. Evid: 172.
 * Event description: Event for the first call that the app was served (first is alive), (html loaded).

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutOpenInitiatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutOpenInitiated = function (params) {
    return { evid: 172, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardWidgetInfoMouseOverParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {string} type - widget source
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout dashboard-> widget info  mouse over. Evid: 200.
 * Event description: mouse over on the info (i) icon in the widget.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * type - Type: string. Desc: widget source
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutDashboardWidgetInfoMouseOverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardWidgetInfoMouseOver = function (params) {
    return { evid: 200, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutsCardClickOnActionParams
* @property {string} campaign_source - web/mobile
* @property {string} context - context
* @property {GUID} message_id - if exists
* @property {string} message_type - published, draft, schedule, etc...
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} name - action name
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page - dashboard,my campaigns
* @property {GUID} uuid - uuid
* @property {string} value - action value
**/
/**
 * Name: shoutouts-> Card CTA click. Evid: 304.
 * Event description: click on one of the actions in "my shoutouts" page - instead of existing events.

 * campaign_source - Type: string. Desc: web/mobile
 *
 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: if exists
 *
 * message_type - Type: string. Desc: published, draft, schedule, etc...
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: action name
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page - Type: string. Desc: dashboard,my campaigns
 *
 * uuid - Type: guid. Desc: uuid
 *
 * value - Type: string. Desc: action value
 * @param {shoutoutMyShoutoutsCardClickOnActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutsCardClickOnAction = function (params) {
    return { evid: 304, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsSelectContactParams
* @property {string} contact_id - null
* @property {string} context - null
* @property {string} method - by which method the user added (new/checkbox/autocomplete)
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {boolean} selected - true/false (if the user was selected or deselected)
* @property {string} type - select label(group)/contact
* @property {string} type_id - identifier of selected type object
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout contacts -> select contact. Evid: 22.


 * contact_id - Type: string.
 *
 * context - Type: string.
 *
 * method - Type: string. Desc: by which method the user added (new/checkbox/autocomplete)
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * selected - Type: bool. Desc: true/false (if the user was selected or deselected)
 *
 * type - Type: string. Desc: select label(group)/contact
 *
 * type_id - Type: string. Desc: identifier of selected type object
 *
 * uuid - Type: guid.
 * @param {shoutoutContactsSelectContactParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsSelectContact = function (params) {
    return { evid: 22, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutCampaignNameChangedParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} new_name - new name of the campaign
* @property {string} old_name - old name of the campaign
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page - dashboard / my_campaigns / campaign_stats
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout - campaign name changed. Evid: 367.
 * Event description: when user changes campaign name.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * new_name - Type: string. Desc: new name of the campaign
 *
 * old_name - Type: string. Desc: old name of the campaign
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page - Type: string. Desc: dashboard / my_campaigns / campaign_stats
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutCampaignNameChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutCampaignNameChanged = function (params) {
    return { evid: 367, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostPreviewAdPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost preview -> ad page view. Evid: 181.
 * Event description: ad page view.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostPreviewAdPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostPreviewAdPageView = function (params) {
    return { evid: 181, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} captchaViewParams
* @property {string} context - null
* @property {string} location - send page/ test mail.  did the  user click on the test, or on the send shoutout button
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: captcha view. Evid: 119.
 * Event description: captcha view - when user send a SO message (test or real SO) captcha is display  in order to prevent bots from sending mails.

 * context - Type: string.
 *
 * location - Type: string. Desc: send page/ test mail.  did the  user click on the test, or on the send shoutout button
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {captchaViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var captchaView = function (params) {
    return { evid: 119, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostPaymentPlaceAdClickSuccessParams
* @property {string} adAccountId - ad_accountId
* @property {string} adCampaignId - ad_campaign_id
* @property {string} adId - ad ID
* @property {string} adContent - ad Content
* @property {string} adurl - ad url
* @property {number} budget - ad budget
* @property {string} context - null
* @property {number} cpm - ad cpm
* @property {string} currency - payment currency
* @property {boolean} customAudienceIncluded - custom_audience_Included
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {number} reachByBudgetMax - reachByBudgetMax
* @property {number} reachByBudgetMin - reachByBudgetMin
* @property {number} reachMax - reachMax
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost payment -> place_ad_click_success. Evid: 193.
 * Event description: ad is placed successfully.

 * adAccountId - Type: string. Desc: ad_accountId
 *
 * adCampaignId - Type: string. Desc: ad_campaign_id
 *
 * adId - Type: string. Desc: ad ID
 *
 * adContent - Type: string. Desc: ad Content
 *
 * adurl - Type: string. Desc: ad url
 *
 * budget - Type: numeric. Desc: ad budget
 *
 * context - Type: string.
 *
 * cpm - Type: numeric. Desc: ad cpm
 *
 * currency - Type: string. Desc: payment currency
 *
 * customAudienceIncluded - Type: bool. Desc: custom_audience_Included
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * reachByBudgetMax - Type: numeric. Desc: reachByBudgetMax
 *
 * reachByBudgetMin - Type: numeric. Desc: reachByBudgetMin
 *
 * reachMax - Type: numeric. Desc: reachMax
 *
 * uuid - Type: guid.
 * @param {fbBoostPaymentPlaceAdClickSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostPaymentPlaceAdClickSuccess = function (params) {
    return { evid: 193, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageDmarcDialogBuyMailboxClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page dmarc dialog-> buy mailbox click. Evid: 157.
 * Event description: Clicking on Mailbox purchase on DMARC warning lightbox (enter a Yahoo email).

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageDmarcDialogBuyMailboxClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageDmarcDialogBuyMailboxClick = function (params) {
    return { evid: 157, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardModalClickParams
* @property {string} context - context
* @property {string} cta_type - send, pause, cancel
* @property {string} ml_translation_language - null
* @property {string} modal_type - the type of the modal (send, pause)
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page - dashboard,my campaigns
* @property {GUID} uuid - uuid
* @property {string} value - updated value (created for toggle)
**/
/**
 * Name: shoutout - -> modal cta click - generic. Evid: 299.
 * Event description: click on modal in "dashboard"/"my campaigns" page.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: send, pause, cancel
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: the type of the modal (send, pause)
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page - Type: string. Desc: dashboard,my campaigns
 *
 * uuid - Type: guid. Desc: uuid
 *
 * value - Type: string. Desc: updated value (created for toggle)
 * @param {shoutoutDashboardModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardModalClick = function (params) {
    return { evid: 299, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teComposerModalViewParams
* @property {string} context - context (TE/APeS...)
* @property {string} ml_translation_language - null
* @property {string} modal_name - name of the modal(example: Reset template)
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE -  composer modal view. Evid: 341.
 * Event description: generic modal view in the composer.

 * context - Type: string. Desc: context (TE/APeS...)
 *
 * ml_translation_language - Type: string.
 *
 * modal_name - Type: string. Desc: name of the modal(example: Reset template)
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teComposerModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teComposerModalView = function (params) {
    return { evid: 341, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} tipsLightboxCancelClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: tips lightbox cancel click. Evid: 118.
 * Event description: event is triggered when the user is clicking on "cancel" in the lightbox in shoutout contacts page, giving qty limitation for the number of contacts..

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {tipsLightboxCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tipsLightboxCancelClick = function (params) {
    return { evid: 118, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeNextPageParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} template_name - template name
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> next page. Evid: 15.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * template_name - Type: string. Desc: template name
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeNextPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeNextPage = function (params) {
    return { evid: 15, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSidebarSubscribeFormClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout sidebar -> Subscribe Form click. Evid: 67.
 * Event description: Click on Subscribe Form.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSidebarSubscribeFormClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSidebarSubscribeFormClick = function (params) {
    return { evid: 67, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teOpenAppParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - open source
* @property {GUID} uuid - uuid
**/
/**
 * Name: TE - open app. Evid: 277.
 * Event description: open app - cross.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: open source
 *
 * uuid - Type: guid. Desc: uuid
 * @param {teOpenAppParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teOpenApp = function (params) {
    return { evid: 277, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPreviewBackClickParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout preview -> back click. Evid: 55.
 * Event description: PREVIEW_BACK_CLICK.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {shoutoutPreviewBackClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPreviewBackClick = function (params) {
    return { evid: 55, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPackagePickerBuyNowParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout package picker -> buy now. Evid: 42.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutPackagePickerBuyNowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPackagePickerBuyNow = function (params) {
    return { evid: 42, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeThemeSelectParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} theme_selected - name of hte
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout compose - theme select. Evid: 368.
 * Event description: when user selects a new theme.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * theme_selected - Type: string. Desc: name of hte
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutComposeThemeSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeThemeSelect = function (params) {
    return { evid: 368, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teCreateNewTeParams
* @property {string} context - context - TE
* @property {string} location - which of the exist buttons clicked on
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - create new TE. Evid: 262.
 * Event description: click to create a new TE which will open the composer.

 * context - Type: string. Desc: context - TE
 *
 * location - Type: string. Desc: which of the exist buttons clicked on
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teCreateNewTeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teCreateNewTe = function (params) {
    return { evid: 262, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerAssistanceTaskCtaClickParams
* @property {string} context - context
* @property {string} cta_type - apply, dismiss, upgrade, not now
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} rule - unique rule id
* @property {string} task_type - text, button, link, social....
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer - assistance task cta click. Evid: 330.
 * Event description: user click on a task cta.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: apply, dismiss, upgrade, not now
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * rule - Type: string. Desc: unique rule id
 *
 * task_type - Type: string. Desc: text, button, link, social....
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerAssistanceTaskCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerAssistanceTaskCtaClick = function (params) {
    return { evid: 330, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutHistoryBackToComposerParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout history -> back to composer. Evid: 61.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutHistoryBackToComposerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutHistoryBackToComposer = function (params) {
    return { evid: 61, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutOutOfQuotaTooltipParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} quota_type - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout -> out of quota notification. Evid: 44.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * quota_type - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutOutOfQuotaTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutOutOfQuotaTooltip = function (params) {
    return { evid: 44, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeDoneClickParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> done click. Evid: 56.
 * Event description: COMPOSER_DONE_CLICK.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeDoneClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeDoneClick = function (params) {
    return { evid: 56, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} senderDetailsPublicDomainValidationMessageViewParams
* @property {string} context - null
* @property {string} domain - the domain that triggered the message
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - the app which the feature was opened from
* @property {GUID} uuid - uuid
**/
/**
 * Name: sender details - public domain validation message view. Evid: 235.
 * Event description: when users enter a public domain name he get this message.

 * context - Type: string.
 *
 * domain - Type: string. Desc: the domain that triggered the message
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: the app which the feature was opened from
 *
 * uuid - Type: guid. Desc: uuid
 * @param {senderDetailsPublicDomainValidationMessageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var senderDetailsPublicDomainValidationMessageView = function (params) {
    return { evid: 235, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsTabViewParams
* @property {string} context - context
* @property {GUID} message_id - NA
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} origin - "the origin to the page, where the user came from: optional values: dashboard/my shoutouts"
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
* @property {string} prev_tab - "the previous tab the user was on before views this on,  if this is the first one then return 'no prev tab'"
* @property {string} tab_shown - "the name of the tab that the user views optional values: email stats/ email recipients/ social stats"
* @property {string} tab_status - "the status of the tab, if empty or not optional values: empty_state/full_data"
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats-> tab view. Evid: 313.
 * Event description: when the user views each one of the tabs in the stat page.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: NA
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: "the origin to the page, where the user came from: optional values: dashboard/my shoutouts"
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page_status - Type: string. Desc: "the status of the page, if empty or not optional values: empty_state/full_data"
 *
 * prev_tab - Type: string. Desc: "the previous tab the user was on before views this on,  if this is the first one then return 'no prev tab'"
 *
 * tab_shown - Type: string. Desc: "the name of the tab that the user views optional values: email stats/ email recipients/ social stats"
 *
 * tab_status - Type: string. Desc: "the status of the tab, if empty or not optional values: empty_state/full_data"
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsTabViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsTabView = function (params) {
    return { evid: 313, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSidebarContactsClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout sidebar -> contacts click. Evid: 65.
 * Event description: Click on contacts.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSidebarContactsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSidebarContactsClick = function (params) {
    return { evid: 65, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeGoToTopClickParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> go to top click. Evid: 322.
 * Event description: in composer, when user drill sown to bottom , he can click on the 'go to top' button which will  bring him to top.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeGoToTopClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeGoToTopClick = function (params) {
    return { evid: 322, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageDmarcDialogViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page dmarc dialog-> view. Evid: 159.
 * Event description: Showing DMARC warning lightbox (enter a Yahoo email).

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageDmarcDialogViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageDmarcDialogView = function (params) {
    return { evid: 159, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageSubjectNotificationTipViewParams
* @property {string} context - null
* @property {number} errorCode - null
* @property {string} error_name - string format for error code
* @property {boolean} is_resend - was action performed in resend to non-openers flow
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} subject - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page -> subject notification tip view. Evid: 138.
 * Event description: when editing the subject , and a notification box opens.

 * context - Type: string.
 *
 * errorCode - Type: numeric.
 *
 * error_name - Type: string. Desc: string format for error code
 *
 * is_resend - Type: bool. Desc: was action performed in resend to non-openers flow
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * subject - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageSubjectNotificationTipViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageSubjectNotificationTipView = function (params) {
    return { evid: 138, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teMessageDetailsModalViewParams
* @property {string} context - context - TE
* @property {string} email_id - email_id
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {string} modal_type - published success,code snippets
* @property {GUID} msid - msid
* @property {number} number_of_placeholders - number_of_placeholders
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} subject - subject
* @property {GUID} uuid - null
**/
/**
 * Name: TE - message details modal view. Evid: 251.
 * Event description: when click on save  and published and sender details are sets. get the success modal
or when clicking  on code script from the dashboard. this event contain subject value so we know the last value of the subject or if the user changed it.

 * context - Type: string. Desc: context - TE
 *
 * email_id - Type: string. Desc: email_id
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: published success,code snippets
 *
 * msid - Type: guid. Desc: msid
 *
 * number_of_placeholders - Type: numeric. Desc: number_of_placeholders
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * subject - Type: string. Desc: subject
 *
 * uuid - Type: guid.
 * @param {teMessageDetailsModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teMessageDetailsModalView = function (params) {
    return { evid: 251, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teTextComponentAddDynamicVariableClickParams
* @property {string} context - context - TE
* @property {string} location - text-region/subject
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - text component add dynamic  variable click. Evid: 241.
 * Event description: click to add a variable.

 * context - Type: string. Desc: context - TE
 *
 * location - Type: string. Desc: text-region/subject
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teTextComponentAddDynamicVariableClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teTextComponentAddDynamicVariableClick = function (params) {
    return { evid: 241, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsShareClickParams
* @property {string} context - null
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - "the origin for the share click optional values: share modal/social stats tab"
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
* @property {string} value - share value
**/
/**
 * Name: shoutout stats-> share click. Evid: 170.
 * Event description: Clicking on Share icon and choosing platform in a stats page view.

 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: "the origin for the share click optional values: share modal/social stats tab"
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 *
 * value - Type: string. Desc: share value
 * @param {shoutoutStatsShareClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsShareClick = function (params) {
    return { evid: 170, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} senderDetailsWidgetViewParams
* @property {string} context - context
* @property {string} domain_authentication_status - authenticated / not authenticated
* @property {string} domainmanagementstatus - public / private / managed
* @property {string} from_name - from_name
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} reply_to_name - reply_to_name
* @property {string} sender_details_status - verified / unverified
* @property {GUID} uuid - uuid
**/
/**
 * Name: sender details - widget view. Evid: 362.
 * Event description: when user views sender details widget.

 * context - Type: string. Desc: context
 *
 * domain_authentication_status - Type: string. Desc: authenticated / not authenticated
 *
 * domainmanagementstatus - Type: string. Desc: public / private / managed
 *
 * from_name - Type: string. Desc: from_name
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * reply_to_name - Type: string. Desc: reply_to_name
 *
 * sender_details_status - Type: string. Desc: verified / unverified
 *
 * uuid - Type: guid. Desc: uuid
 * @param {senderDetailsWidgetViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var senderDetailsWidgetView = function (params) {
    return { evid: 362, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emPremiumProductUpgradeButtonHoverParams
* @property {string} button_location - Where the button is in the page
* @property {string} context - context
* @property {string} cycle_name - name of the current user EM premium cycle
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - Page on which the event fires
* @property {string} package_group - EM package group
* @property {string} package_id - EM package ID
* @property {GUID} uuid - null
**/
/**
 * Name: EM Premium Product - Upgrade Button Hover. Evid: 378.
 * Event description: Event fires on upgrade button hover.

 * button_location - Type: string. Desc: Where the button is in the page
 *
 * context - Type: string. Desc: context
 *
 * cycle_name - Type: string. Desc: name of the current user EM premium cycle
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: Page on which the event fires
 *
 * package_group - Type: string. Desc: EM package group
 *
 * package_id - Type: string. Desc: EM package ID
 *
 * uuid - Type: guid.
 * @param {emPremiumProductUpgradeButtonHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emPremiumProductUpgradeButtonHover = function (params) {
    return { evid: 378, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerAssistancePopoverCloseParams
* @property {string} context - context
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {number} number_of_tasks - number of open tasks - if exists
* @property {string} origin - the triggered for close  - on stage, icon click, x click
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} step - welcome, tasts list, success
* @property {string} tasks_list - json with all tasks types with rule id - if exists
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer -  assistance popover close. Evid: 324.
 * Event description: generic event for closing th epopover in any of its steps.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * number_of_tasks - Type: numeric. Desc: number of open tasks - if exists
 *
 * origin - Type: string. Desc: the triggered for close  - on stage, icon click, x click
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * step - Type: string. Desc: welcome, tasts list, success
 *
 * tasks_list - Type: string. Desc: json with all tasks types with rule id - if exists
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerAssistancePopoverCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerAssistancePopoverClose = function (params) {
    return { evid: 324, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeItemAddClickParams
* @property {string} adding_method - click / drag
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} subtype - subtype for region type
* @property {string} type - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> item add click. Evid: 12.


 * adding_method - Type: string. Desc: click / drag
 *
 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * subtype - Type: string. Desc: subtype for region type
 *
 * type - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeItemAddClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeItemAddClick = function (params) {
    return { evid: 12, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageDmarcDialogCloseClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page dmarc dialog-> close click. Evid: 158.
 * Event description: Closing DMARC warning lightbox (enter a Yahoo email).

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageDmarcDialogCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageDmarcDialogCloseClick = function (params) {
    return { evid: 158, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutLpShareButtonParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
* @property {string} value - null
**/
/**
 * Name: shoutout lp -> share button. Evid: 101.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 *
 * value - Type: string.
 * @param {shoutoutLpShareButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutLpShareButton = function (params) {
    return { evid: 101, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutHtmlIntroductionModalLearnMoreClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout html -> introduction modal learn more click. Evid: 278.
 * Event description: click on the learn more button on the modal.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutHtmlIntroductionModalLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutHtmlIntroductionModalLearnMoreClick = function (params) {
    return { evid: 278, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutOnboardingCloseClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout onboarding -> close click. Evid: 173.
 * Event description: click on close
when user goes on the onboarding flow. Onboarding is for new users (4 GIFS, one after another).

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutOnboardingCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutOnboardingCloseClick = function (params) {
    return { evid: 173, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emPremiumProductModalShownParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {string} modal_name - Reason why the modal was shown
* @property {GUID} msid - null
* @property {string} origin - Page on which the event fires
* @property {string} package_group - EM package group
* @property {string} package_id - EM package ID
* @property {GUID} uuid - null
**/
/**
 * Name: EM Premium Product - Modal Shown. Evid: 376.
 * Event description: Event for EM premium product modal shown (Paywall).

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * modal_name - Type: string. Desc: Reason why the modal was shown
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: Page on which the event fires
 *
 * package_group - Type: string. Desc: EM package group
 *
 * package_id - Type: string. Desc: EM package ID
 *
 * uuid - Type: guid.
 * @param {emPremiumProductModalShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emPremiumProductModalShown = function (params) {
    return { evid: 376, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutout123StepsHeaderLogoClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout 1-2-3 steps header -> logo click. Evid: 121.
 * Event description: in the shoutout  1-2-3 steps page header - click on the shoutout logo.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutout123StepsHeaderLogoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutout123StepsHeaderLogoClick = function (params) {
    return { evid: 121, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWidgetListViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {number} total - null
* @property {number} total_sent - null
* @property {number} total_views - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout widget-> list view. Evid: 80.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * total - Type: numeric.
 *
 * total_sent - Type: numeric.
 *
 * total_views - Type: numeric.
 *
 * uuid - Type: guid.
 * @param {shoutoutWidgetListViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWidgetListView = function (params) {
    return { evid: 80, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emWebComposerComponentInfoTooltipViewParams
* @property {string} component_name - image/columns/social....
* @property {string} context - null
* @property {boolean} is_first - true if it's the first time the user opens the composer
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: em web - composer component info tooltip view. Evid: 335.
 * Event description: when a user hover on the info tooltip.

 * component_name - Type: string. Desc: image/columns/social....
 *
 * context - Type: string.
 *
 * is_first - Type: bool. Desc: true if it's the first time the user opens the composer
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {emWebComposerComponentInfoTooltipViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emWebComposerComponentInfoTooltipView = function (params) {
    return { evid: 335, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSendToUnsubscribedLearnMoreCtaParams
* @property {string} context - context
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: TE - send to unsubscribed learn more cta. Evid: 373.
 * Event description: When a user clicks on kb link about 'send to unsubscribed'.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {teSendToUnsubscribedLearnMoreCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSendToUnsubscribedLearnMoreCta = function (params) {
    return { evid: 373, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersSettingsFormNotificationSwitchParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {boolean} status - true:On, false:Off
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers settings - form notification switch. Evid: 210.
 * Event description: Switching email notification on/off.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * status - Type: bool. Desc: true:On, false:Off
 *
 * uuid - Type: guid.
 * @param {getSubscribersSettingsFormNotificationSwitchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersSettingsFormNotificationSwitch = function (params) {
    return { evid: 210, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeMoveComponentParams
* @property {string} component_type - the type of the component moved
* @property {string} context - context of mail
* @property {boolean} is_title - is title region
* @property {string} ml_translation_language - null
* @property {number} move_delta - positive=up, negative=down, 0=no change
* @property {string} move_type - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose - move component. Evid: 347.
 * Event description: event triggered when user leaves the component he meant to move.

 * component_type - Type: string. Desc: the type of the component moved
 *
 * context - Type: string. Desc: context of mail
 *
 * is_title - Type: bool. Desc: is title region
 *
 * ml_translation_language - Type: string.
 *
 * move_delta - Type: numeric. Desc: positive=up, negative=down, 0=no change
 *
 * move_type - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeMoveComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeMoveComponent = function (params) {
    return { evid: 347, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} oneAppCreateShoutoutParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - "+" button or "create shoutout" CTA
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: one app - create shoutout. Evid: 208.
 * Event description: when user is clicking "create shoutout" or "+" button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: "+" button or "create shoutout" CTA
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {oneAppCreateShoutoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oneAppCreateShoutout = function (params) {
    return { evid: 208, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teMessageDetailsModalCtaClickParams
* @property {string} context - context - TE
* @property {string} cta_type - got it
* @property {string} email_id - email_id
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {string} modal_type - published success,code snippets
* @property {GUID} msid - msid
* @property {number} number_of_placeholders - number_of_placeholders
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} subject - subject
* @property {GUID} uuid - null
**/
/**
 * Name: TE - message details modal cta click. Evid: 252.
 * Event description: click on a cta in the modal.

 * context - Type: string. Desc: context - TE
 *
 * cta_type - Type: string. Desc: got it
 *
 * email_id - Type: string. Desc: email_id
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: published success,code snippets
 *
 * msid - Type: guid. Desc: msid
 *
 * number_of_placeholders - Type: numeric. Desc: number_of_placeholders
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * subject - Type: string. Desc: subject
 *
 * uuid - Type: guid.
 * @param {teMessageDetailsModalCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teMessageDetailsModalCtaClick = function (params) {
    return { evid: 252, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutsModalClickParams
* @property {string} context - context
* @property {string} cta_type - send, pause, cancel
* @property {string} ml_translation_language - null
* @property {string} modal_type - the type of the modal (send, pause)
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout my shoutouts- -> modal click. Evid: 297.
 * Event description: click on modal in "my shoutouts" page.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: send, pause, cancel
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: the type of the modal (send, pause)
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutMyShoutoutsModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutsModalClick = function (params) {
    return { evid: 297, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutEditorPanelCloseParams
* @property {string} context - null
* @property {GUID} esi - esi for SO in Editor
* @property {boolean} is_first - is first time user used the panel
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - shoutout editor panel
* @property {GUID} site_id - site_id for SO in Editor
* @property {number} ts - ts for SO in Editor
* @property {GUID} uuid - null
* @property {string} viewmode - ts for SO in Editor
**/
/**
 * Name: shoutout editor panel-> close. Evid: 90.
 * Event description: shoutout editor panel-> close.

 * context - Type: string.
 *
 * esi - Type: guid. Desc: esi for SO in Editor
 *
 * is_first - Type: bool. Desc: is first time user used the panel
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: shoutout editor panel
 *
 * site_id - Type: guid. Desc: site_id for SO in Editor
 *
 * ts - Type: numeric. Desc: ts for SO in Editor
 *
 * uuid - Type: guid.
 *
 * viewmode - Type: string. Desc: ts for SO in Editor
 * @param {shoutoutEditorPanelCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutEditorPanelClose = function (params) {
    return { evid: 90, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsAddSegmentsClickParams
* @property {string} context - context
* @property {string} has_segments - does user have segments
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout contacts -> add segments click. Evid: 358.
 * Event description: When user clicks on add segments in contact selection screen.

 * context - Type: string. Desc: context
 *
 * has_segments - Type: string. Desc: does user have segments
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutContactsAddSegmentsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsAddSegmentsClick = function (params) {
    return { evid: 358, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsActiveContactToolTipMessageCloseParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {GUID} page_id - page_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout contacts ->  active contact tool tip message close. Evid: 230.
 * Event description: click on close in the tool tip.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * page_id - Type: guid. Desc: page_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutContactsActiveContactToolTipMessageCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsActiveContactToolTipMessageClose = function (params) {
    return { evid: 230, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teEditPublishedWarningModalViewParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - edit published notification modal view. Evid: 257.
 * Event description: when edit a publushed, gets a blue line on the top of the screen with warning.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teEditPublishedWarningModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teEditPublishedWarningModalView = function (params) {
    return { evid: 257, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMessageClickParams
* @property {string} context - null
* @property {string} cta_type - name of the button clicked (dismiss/go to automations..))
* @property {string} message_name - unique name of the message
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page - the page where the message is shown (dashboard, composer..))
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout - message click. Evid: 337.
 * Event description: Generic event for message click from any page in shoutout.

 * context - Type: string.
 *
 * cta_type - Type: string. Desc: name of the button clicked (dismiss/go to automations..))
 *
 * message_name - Type: string. Desc: unique name of the message
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page - Type: string. Desc: the page where the message is shown (dashboard, composer..))
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutMessageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMessageClick = function (params) {
    return { evid: 337, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutClickOnUpgradeParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page_name - null
* @property {string} promotion_type -  promotion type from which the click was fired. replacing origin
* @property {string} quota_type - null
* @property {GUID} uuid - null
* @property {string} value - null
**/
/**
 * Name: shoutout -> click on upgrade. Evid: 47.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_name - Type: string.
 *
 * promotion_type - Type: string. Desc:  promotion type from which the click was fired. replacing origin
 *
 * quota_type - Type: string.
 *
 * uuid - Type: guid.
 *
 * value - Type: string.
 * @param {shoutoutClickOnUpgradeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutClickOnUpgrade = function (params) {
    return { evid: 47, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutNotificationPresentNotificationDialogParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout notification -> present notification dialog. Evid: 94.
 * Event description: present notification dialog.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutNotificationPresentNotificationDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutNotificationPresentNotificationDialog = function (params) {
    return { evid: 94, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} smartTriggersCustomizeNextClickParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: smart triggers customize -> next click. Evid: 38.
 * Event description: ST_CUSTOMIZE_NEXT_CLICK.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {smartTriggersCustomizeNextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartTriggersCustomizeNextClick = function (params) {
    return { evid: 38, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teMessageDetailsLearnMoreClickParams
* @property {string} context - context - TE
* @property {string} email_id - email_id
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {string} modal_type - published success,code snippets
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - message details learn more click. Evid: 264.
 * Event description: in the message details modal, click on learn more.

 * context - Type: string. Desc: context - TE
 *
 * email_id - Type: string. Desc: email_id
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: published success,code snippets
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teMessageDetailsLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teMessageDetailsLearnMoreClick = function (params) {
    return { evid: 264, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostSetUpSelectPageClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost set up -> select page click. Evid: 179.
 * Event description: selecting facebook page.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostSetUpSelectPageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostSetUpSelectPageClick = function (params) {
    return { evid: 179, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeReturningUserSsmDialogShowClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose returning user ssm -> dialog  show click. Evid: 142.
 * Event description: Clicking 'show' on returning-user tips dialog
returning user dialog view opens when user returning first time and open composer
ssm - shoutout styling model.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeReturningUserSsmDialogShowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeReturningUserSsmDialogShowClick = function (params) {
    return { evid: 142, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutRenameModalCtaParams
* @property {string} context - context
* @property {string} cta_type - send, pause, cancel
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page - page in which the modal was clicked
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout - rename modal cta. Evid: 365.
 * Event description: when user clicks within rename campaign modal.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: send, pause, cancel
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page - Type: string. Desc: page in which the modal was clicked
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutRenameModalCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutRenameModalCta = function (params) {
    return { evid: 365, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutLpHomeLinkParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} page_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout lp -> home link. Evid: 103.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: guid.
 *
 * uuid - Type: guid.
 * @param {shoutoutLpHomeLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutLpHomeLink = function (params) {
    return { evid: 103, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutEditorPanelCloseTemplateFrameParams
* @property {string} context - null
* @property {GUID} esi - esi for SO in Editor
* @property {boolean} is_first - is first time user used the panel
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - shoutout editor panel
* @property {number} ts - ts for SO in Editor
* @property {GUID} uuid - null
* @property {string} viewmode - viewmode for SO in Editor
**/
/**
 * Name: shoutout editor panel-> close template frame. Evid: 91.
 * Event description: shoutout editor panel-> close template frame.

 * context - Type: string.
 *
 * esi - Type: guid. Desc: esi for SO in Editor
 *
 * is_first - Type: bool. Desc: is first time user used the panel
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: shoutout editor panel
 *
 * ts - Type: numeric. Desc: ts for SO in Editor
 *
 * uuid - Type: guid.
 *
 * viewmode - Type: string. Desc: viewmode for SO in Editor
 * @param {shoutoutEditorPanelCloseTemplateFrameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutEditorPanelCloseTemplateFrame = function (params) {
    return { evid: 91, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} htmlComponentSanitizationParams
* @property {string} all_attributes - All html syntax attributes
* @property {string} all_tags - All html syntax tags
* @property {string} context - EM context
* @property {string} invalid_attributes - All invalid html syntax attributes
* @property {string} invalid_tags - All invalid html syntax tags
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - EM package group
* @property {string} package_id - null
* @property {GUID} uuid - null
* @property {string} warning_msg - warning message context
**/
/**
 * Name: HTML Component Sanitization. Evid: 374.
 * Event description: Event fires on html component sanitization (Click on 'Apply').

 * all_attributes - Type: string. Desc: All html syntax attributes
 *
 * all_tags - Type: string. Desc: All html syntax tags
 *
 * context - Type: string. Desc: EM context
 *
 * invalid_attributes - Type: string. Desc: All invalid html syntax attributes
 *
 * invalid_tags - Type: string. Desc: All invalid html syntax tags
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string. Desc: EM package group
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 *
 * warning_msg - Type: string. Desc: warning message context
 * @param {htmlComponentSanitizationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var htmlComponentSanitization = function (params) {
    return { evid: 374, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerClickOnAssistanceIconParams
* @property {string} context - context
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer - click on assistance icon. Evid: 323.
 * Event description: in composer click on assistance.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerClickOnAssistanceIconParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerClickOnAssistanceIcon = function (params) {
    return { evid: 323, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutCompleteDialogDoneClickParams
* @property {string} action_complete - publish/ send or schedule
* @property {string} context - null
* @property {boolean} is_resend - was action performed in resend to non-openers flow
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout complete dialog done->  click. Evid: 163.
 * Event description: Clicking on Done in completion dialog.

 * action_complete - Type: string. Desc: publish/ send or schedule
 *
 * context - Type: string.
 *
 * is_resend - Type: bool. Desc: was action performed in resend to non-openers flow
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutCompleteDialogDoneClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutCompleteDialogDoneClick = function (params) {
    return { evid: 163, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutChooseContactsImportClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {number} total_contacts - total number of contacts in list
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout choose contacts -> import click. Evid: 123.
 * Event description: in shoutout contacts (step 2) click on "import contacts".

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * total_contacts - Type: numeric. Desc: total number of contacts in list
 *
 * uuid - Type: guid.
 * @param {shoutoutChooseContactsImportClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutChooseContactsImportClick = function (params) {
    return { evid: 123, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWidgetReuseMessageClickParams
* @property {string} context - null
* @property {number} index - null
* @property {GUID} message_id - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout widget-> reuse message click. Evid: 85.


 * context - Type: string.
 *
 * index - Type: numeric.
 *
 * message_id - Type: guid.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWidgetReuseMessageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWidgetReuseMessageClick = function (params) {
    return { evid: 85, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWellDoneStartOverParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout well done -> start over. Evid: 53.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWellDoneStartOverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWellDoneStartOver = function (params) {
    return { evid: 53, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostSetUpPagePermissionClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost set up -> page permission click. Evid: 178.
 * Event description: click on grant page permission.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostSetUpPagePermissionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostSetUpPagePermissionClick = function (params) {
    return { evid: 178, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostBudgetNextClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost budget -> next click. Evid: 188.
 * Event description: clicking on next button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostBudgetNextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostBudgetNextClick = function (params) {
    return { evid: 188, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSavingChangesModalViewParams
* @property {string} context - context - TE
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - saving changes modal view. Evid: 269.
 * Event description: open a published to edit and click on save you get this modal.

 * context - Type: string. Desc: context - TE
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teSavingChangesModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSavingChangesModalView = function (params) {
    return { evid: 269, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeCancelClickParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> cancel click. Evid: 57.
 * Event description: COMPOSER_CANCEL_CLICK.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeCancelClick = function (params) {
    return { evid: 57, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teComposerDynamicVariableModalViewParams
* @property {string} context - context (TE/APeS...)
* @property {string} ml_translation_language - null
* @property {string} modal_type - type of the modal(e.g Subject and preview)
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE - composer dynamic variable modal view. Evid: 338.
 * Event description: dynamic variable modal view open.

 * context - Type: string. Desc: context (TE/APeS...)
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: type of the modal(e.g Subject and preview)
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teComposerDynamicVariableModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teComposerDynamicVariableModalView = function (params) {
    return { evid: 338, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teFirstTimeExperienceViewParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - first time experience view. Evid: 238.
 * Event description: first time page load.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teFirstTimeExperienceViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teFirstTimeExperienceView = function (params) {
    return { evid: 238, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsActiveContactLearnMoreClickParams
* @property {string} context - tooltip/warning massage/good looking/no active users
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {GUID} page_id - page_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout contacts -> active contact learn more click. Evid: 228.
 * Event description: click on one of the links for learn more.

 * context - Type: string. Desc: tooltip/warning massage/good looking/no active users
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * page_id - Type: guid. Desc: page_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutContactsActiveContactLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsActiveContactLearnMoreClick = function (params) {
    return { evid: 228, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostBudgetEditGenderClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost budget -> edit gender click. Evid: 187.
 * Event description: changing targeted gender.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostBudgetEditGenderClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostBudgetEditGenderClick = function (params) {
    return { evid: 187, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutLpPageView100Params
* @property {string} context - null
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout lp -> page view. Evid: 100.


 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutLpPageView100Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutLpPageView100 = function (params) {
    return { evid: 100, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutDeleteDialogViewParams
* @property {string} context - null
* @property {string} messages_type - draft/published
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page - dashboard,my campaigns
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout my shoutout delete dialog-> view. Evid: 128.
 * Event description: in my shoutout , on one of the SO items after click on delete - the "delete dialog" opens.

 * context - Type: string.
 *
 * messages_type - Type: string. Desc: draft/published
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page - Type: string. Desc: dashboard,my campaigns
 *
 * uuid - Type: guid.
 * @param {shoutoutMyShoutoutDeleteDialogViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutDeleteDialogView = function (params) {
    return { evid: 128, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsPageViewParams
* @property {string} campain_status - "the status of the campaign optional values: sent/published/sent and published"
* @property {string} context - null
* @property {GUID} message_id - NA
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - "the origin to the page, where the user came from: optional values: dashboard/my shoutouts"
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
* @property {string} stats_data - json with all the stats data of the site
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout stats-> page view. Evid: 105.
 * Event description: stats page view.

 * campain_status - Type: string. Desc: "the status of the campaign optional values: sent/published/sent and published"
 *
 * context - Type: string.
 *
 * message_id - Type: guid. Desc: NA
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: "the origin to the page, where the user came from: optional values: dashboard/my shoutouts"
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_status - Type: string. Desc: "the status of the page, if empty or not optional values: empty_state/full_data"
 *
 * stats_data - Type: string. Desc: json with all the stats data of the site
 *
 * uuid - Type: guid.
 * @param {shoutoutStatsPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsPageView = function (params) {
    return { evid: 105, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutHistoryClickOnAccountHistoryParams
* @property {string} context - null
* @property {GUID} message_id - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout history -> click on account history. Evid: 60.


 * context - Type: string.
 *
 * message_id - Type: guid.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutHistoryClickOnAccountHistoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutHistoryClickOnAccountHistory = function (params) {
    return { evid: 60, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutQuotaChangeModalCtaParams
* @property {string} context - context
* @property {string} cta_type - cta
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout -> quota change modal cta. Evid: 371.
 * Event description: when user clicks on one of the CTAs in quota change modal.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: cta
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutQuotaChangeModalCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutQuotaChangeModalCta = function (params) {
    return { evid: 371, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageDmarcDialogWarningClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page dmarc dialog-> warning click. Evid: 160.
 * Event description: Clicking on DMARC warning link (enter a Yahoo email).

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageDmarcDialogWarningClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageDmarcDialogWarningClick = function (params) {
    return { evid: 160, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSaveAsDraftClickParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - save as draft click. Evid: 249.
 * Event description: click on save as draft in the composer.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teSaveAsDraftClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSaveAsDraftClick = function (params) {
    return { evid: 249, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageEmailFocusParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page -> email focus. Evid: 32.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageEmailFocusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageEmailFocus = function (params) {
    return { evid: 32, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutGetSubscribersAddNowClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout get subscribers -> add now click. Evid: 68.
 * Event description: Click on Subscribe Form.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutGetSubscribersAddNowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutGetSubscribersAddNowClick = function (params) {
    return { evid: 68, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutTemplatesDynamicTemplateOnProcessCancelParams
* @property {string} context - shoutout/sosa
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {string} template_list_name - list name(BO) || top/bottom
* @property {string} template_name - template_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout templates -> dynamic template on process cancel. Evid: 225.
 * Event description: templates - choosing a template.

 * context - Type: string. Desc: shoutout/sosa
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * template_list_name - Type: string. Desc: list name(BO) || top/bottom
 *
 * template_name - Type: string. Desc: template_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutTemplatesDynamicTemplateOnProcessCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutTemplatesDynamicTemplateOnProcessCancel = function (params) {
    return { evid: 225, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersSettingsFormFieldNameMandatoryParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {boolean} status - true:On, false:Off
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers settings - form field name mandatory. Evid: 213.
 * Event description: Checking if name is mandatory.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * status - Type: bool. Desc: true:On, false:Off
 *
 * uuid - Type: guid.
 * @param {getSubscribersSettingsFormFieldNameMandatoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersSettingsFormFieldNameMandatory = function (params) {
    return { evid: 213, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutBannedViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout banned -> view. Evid: 167.
 * Event description: user get suspended account view when entering shoutout.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutBannedViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutBannedView = function (params) {
    return { evid: 167, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teAutoAutomationsWidgetViewParams
* @property {GUID} action_id - action_id
* @property {string} context - context
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} rule_id - rule_id
* @property {string} sender_details_status - verified/unverified
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE - template widget view. Evid: 271.
 * Event description: when a preview of a template is previewed in a wi.

 * action_id - Type: guid. Desc: action_id
 *
 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * rule_id - Type: guid. Desc: rule_id
 *
 * sender_details_status - Type: string. Desc: verified/unverified
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teAutoAutomationsWidgetViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teAutoAutomationsWidgetView = function (params) {
    return { evid: 271, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teFirstTimeLearnMoreClickParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - First time learn more click. Evid: 240.
 * Event description: click on the learn more link.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teFirstTimeLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teFirstTimeLearnMoreClick = function (params) {
    return { evid: 240, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSidebarSmartActionsClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout sidebar -> Smart actions click. Evid: 110.
 * Event description: Smart actions click.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSidebarSmartActionsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSidebarSmartActionsClick = function (params) {
    return { evid: 110, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeBackgroundImageSettingsClickParams
* @property {string} context - context
* @property {string} item_value - image name, user custom
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> background image settings click. Evid: 291.
 * Event description: when hover an image, click on the setting cta that become visible
(item = always image is this case..).

 * context - Type: string. Desc: context
 *
 * item_value - Type: string. Desc: image name, user custom
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeBackgroundImageSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeBackgroundImageSettingsClick = function (params) {
    return { evid: 291, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutDeleteDialogDeleteClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page - dashboard,my campaigns
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout my shoutout delete dialog-> delete click. Evid: 127.
 * Event description: in my shoutout , on one of the SO items, in the delete dialog click on "delete".

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page - Type: string. Desc: dashboard,my campaigns
 *
 * uuid - Type: guid.
 * @param {shoutoutMyShoutoutDeleteDialogDeleteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutDeleteDialogDeleteClick = function (params) {
    return { evid: 127, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} smartTriggersCustomizeEditClickParams
* @property {string} context - application context
* @property {string} location - heading/hover/button
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: smart triggers customize -> edit click. Evid: 39.
 * Event description: ST_CUSTOMIZE_EDIT_CLICK.

 * context - Type: string. Desc: application context
 *
 * location - Type: string. Desc: heading/hover/button
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {smartTriggersCustomizeEditClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartTriggersCustomizeEditClick = function (params) {
    return { evid: 39, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsNoActiveContactsViewParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {GUID} page_id - page_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout contacts ->  no active contacts view. Evid: 229.
 * Event description: when users have no active users, he gets the no active contacts view.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * page_id - Type: guid. Desc: page_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutContactsNoActiveContactsViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsNoActiveContactsView = function (params) {
    return { evid: 229, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutOnboardingViewParams
* @property {string} context - null
* @property {string} current_step - current step in onboarding  flow
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout onboarding -> view. Evid: 175.
 * Event description: view
when user goes on the onboarding flow. Onboarding is for new users (4 GIFS, one after another).

 * context - Type: string.
 *
 * current_step - Type: string. Desc: current step in onboarding  flow
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutOnboardingViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutOnboardingView = function (params) {
    return { evid: 175, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostSetUpPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - origin to view
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost set up -> page view. Evid: 165.
 * Event description: facebook boost page view.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: origin to view
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostSetUpPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostSetUpPageView = function (params) {
    return { evid: 165, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} smartTriggersCustomizeTestMailClickParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: smart triggers customize -> test mail click. Evid: 43.
 * Event description: ST_CUSTOMIZE_TEST_EMAIL_CLICK.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {smartTriggersCustomizeTestMailClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartTriggersCustomizeTestMailClick = function (params) {
    return { evid: 43, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutMoveToActiveParams
* @property {string} context - null
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout my shoutout -> move to active. Evid: 132.
 * Event description: in my shoutout , on one of the archived items click on "move to active".

 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutMyShoutoutMoveToActiveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutMoveToActive = function (params) {
    return { evid: 132, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutLpUserSiteLinkParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout lp -> user site link. Evid: 104.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutLpUserSiteLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutLpUserSiteLink = function (params) {
    return { evid: 104, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageClickAddSubjectVariableParams
* @property {string} context - context
* @property {boolean} is_resend - was action performed in resend to non-openers flow
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout send page -> click add subject variable. Evid: 308.
 * Event description: beside the subject line, click on the cta to add a variable , a list of options will be opened..

 * context - Type: string. Desc: context
 *
 * is_resend - Type: bool. Desc: was action performed in resend to non-openers flow
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutSendPageClickAddSubjectVariableParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageClickAddSubjectVariable = function (params) {
    return { evid: 308, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeStyleSelectedParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
* @property {string} value - null
**/
/**
 * Name: shoutout compose -> style selected. Evid: 14.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 *
 * value - Type: string.
 * @param {shoutoutComposeStyleSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeStyleSelected = function (params) {
    return { evid: 14, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutsPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} page_id - na
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout my shoutouts-> page view. Evid: 66.
 * Event description: Click on contacts.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: guid. Desc: na
 *
 * uuid - Type: guid.
 * @param {shoutoutMyShoutoutsPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutsPageView = function (params) {
    return { evid: 66, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teLeaveEditModeModalCtaClickParams
* @property {string} context - context - TE
* @property {string} cta_type - confirm,cancel,close
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - leave edit mode modal cta click. Evid: 256.
 * Event description: when leaving in the middle of editting a published, gets a warning message modal.

 * context - Type: string. Desc: context - TE
 *
 * cta_type - Type: string. Desc: confirm,cancel,close
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teLeaveEditModeModalCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teLeaveEditModeModalCtaClick = function (params) {
    return { evid: 256, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsTooltipViewParams
* @property {string} context - context
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
* @property {string} tooltip_name - the name of the tooltip
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats-> tooltip view. Evid: 319.
 * Event description: when the user views a tooltip.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page_status - Type: string. Desc: "the status of the page, if empty or not optional values: empty_state/full_data"
 *
 * tooltip_name - Type: string. Desc: the name of the tooltip
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsTooltipViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsTooltipView = function (params) {
    return { evid: 319, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageSubjectFocusParams
* @property {string} context - null
* @property {boolean} is_resend - was action performed in resend to non-openers flow
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page -> subject focus. Evid: 34.


 * context - Type: string.
 *
 * is_resend - Type: bool. Desc: was action performed in resend to non-openers flow
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageSubjectFocusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageSubjectFocus = function (params) {
    return { evid: 34, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersSettingsFormMobileMandatoryParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {boolean} status - true:On, false:Off
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers settings - form mobile mandatory. Evid: 211.
 * Event description: Checking if mobile is mandatory.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * status - Type: bool. Desc: true:On, false:Off
 *
 * uuid - Type: guid.
 * @param {getSubscribersSettingsFormMobileMandatoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersSettingsFormMobileMandatory = function (params) {
    return { evid: 211, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} firstTimeExperienceCtaClickParams
* @property {string} context - context
* @property {string} cta_type - start (currently the only value)
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {number} position - index position of selected template
* @property {string} template_id - selected template id
* @property {GUID} template_list_id - selected template list id
* @property {string} template_name - selected template name
* @property {GUID} uuid - null
**/
/**
 * Name: first time experience - cta click. Evid: 312.
 * Event description: generic event for cta click in the first time experience page.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: start (currently the only value)
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * position - Type: numeric. Desc: index position of selected template
 *
 * template_id - Type: string. Desc: selected template id
 *
 * template_list_id - Type: guid. Desc: selected template list id
 *
 * template_name - Type: string. Desc: selected template name
 *
 * uuid - Type: guid.
 * @param {firstTimeExperienceCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstTimeExperienceCtaClick = function (params) {
    return { evid: 312, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} smartTriggersCustomizePageViewParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: smart triggers customize -> page view. Evid: 37.
 * Event description: ST_CUSTOMIZE_PAGE_VIEW.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {smartTriggersCustomizePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartTriggersCustomizePageView = function (params) {
    return { evid: 37, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostPaymentPlaceAdClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost payment -> place ad click. Evid: 192.
 * Event description: clicking on place ad button - launch your ad.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostPaymentPlaceAdClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostPaymentPlaceAdClick = function (params) {
    return { evid: 192, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} oneAppCardActionParams
* @property {string} card - card:"statsCard"/"welcomeCard"/"newSubscribersCard"
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: one app - card action. Evid: 205.
 * Event description: fired after clicking a card in one app feed.

 * card - Type: string. Desc: card:"statsCard"/"welcomeCard"/"newSubscribersCard"
 *
 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {oneAppCardActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oneAppCardAction = function (params) {
    return { evid: 205, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} smartTriggersCustomizeChooseClickParams
* @property {string} context - application context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group (Free/Basic/Pro)
* @property {string} package_id - package - vendor product id
* @property {GUID} uuid - null
**/
/**
 * Name: smart triggers customize -> choose click. Evid: 48.
 * Event description: ST_CUSTOMIZE_CHOOSE_CLICK.

 * context - Type: string. Desc: application context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group (Free/Basic/Pro)
 *
 * package_id - Type: string. Desc: package - vendor product id
 *
 * uuid - Type: guid.
 * @param {smartTriggersCustomizeChooseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartTriggersCustomizeChooseClick = function (params) {
    return { evid: 48, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerAssistanceCompleteAllTasksSucessViewParams
* @property {string} context - context
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer - assistance complete all tasks sucess view. Evid: 331.
 * Event description: user completed all tasks and got the succedss view.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerAssistanceCompleteAllTasksSucessViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerAssistanceCompleteAllTasksSucessView = function (params) {
    return { evid: 331, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPreviewPageBackToEditingClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout preview page -> back to editing click. Evid: 136.
 * Event description: in the shoutout preview page click on "back to editing" button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutPreviewPageBackToEditingClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPreviewPageBackToEditingClick = function (params) {
    return { evid: 136, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeReturningUserSsmTipSkipClickParams
* @property {string} context - null
* @property {string} current - current
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose returning user ssm-> tip skip click. Evid: 145.
 * Event description: closing tips  from the tips dialog
returning user tip view opens when user returning first time and open composer, dialog opens and clicking on "show".

 * context - Type: string.
 *
 * current - Type: string. Desc: current
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeReturningUserSsmTipSkipClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeReturningUserSsmTipSkipClick = function (params) {
    return { evid: 145, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutout123StepsHeaderWizardClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} step - which step
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout 1-2-3 steps header -> wizard click. Evid: 122.
 * Event description: in the shoutout 1-2-3 steps page header - click/moving between steps in 1-2-3.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * step - Type: string. Desc: which step
 *
 * uuid - Type: guid.
 * @param {shoutout123StepsHeaderWizardClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutout123StepsHeaderWizardClick = function (params) {
    return { evid: 122, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutHtmlNotificationModalCloseParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - "got it", "xButton"
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout html -> notification modal close. Evid: 282.
 * Event description: closed the modal by got it or by pressing on X.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: "got it", "xButton"
 *
 * uuid - Type: guid.
 * @param {shoutoutHtmlNotificationModalCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutHtmlNotificationModalClose = function (params) {
    return { evid: 282, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutChooseContactsManageClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout choose contacts -> manage click. Evid: 124.
 * Event description: in shoutout contacts (step 2) click on "manage contacts".

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutChooseContactsManageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutChooseContactsManageClick = function (params) {
    return { evid: 124, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} reuseTemplateModalActionParams
* @property {string} action - name of the action made
* @property {string} action_value - null
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} tab_name - automated_emails/email_campaigns
* @property {GUID} uuid - null
**/
/**
 * Name: Reuse Template Modal Action. Evid: 71.
 * Event description: Any action done in the Reuse Template Modal.

 * action - Type: string. Desc: name of the action made
 *
 * action_value - Type: string.
 *
 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * tab_name - Type: string. Desc: automated_emails/email_campaigns
 *
 * uuid - Type: guid.
 * @param {reuseTemplateModalActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var reuseTemplateModalAction = function (params) {
    return { evid: 71, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsRecipientsApplyFilterParams
* @property {string} apply_type - "how the filter was applyied, by the manual selection in the tab or automaticly by the opening source optional values: manual/automatic"
* @property {string} context - context
* @property {string} filter - "the name of the filter, optional values: Sent/Delivered/opened/clicked/orders/not opened etc..."
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats-> recipients - apply filter. Evid: 316.
 * Event description: when the user applays a filter to the recipients  also will be sent in the open of the tab with the filter already applyied on.

 * apply_type - Type: string. Desc: "how the filter was applyied, by the manual selection in the tab or automaticly by the opening source optional values: manual/automatic"
 *
 * context - Type: string. Desc: context
 *
 * filter - Type: string. Desc: "the name of the filter, optional values: Sent/Delivered/opened/clicked/orders/not opened etc..."
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsRecipientsApplyFilterParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsRecipientsApplyFilter = function (params) {
    return { evid: 316, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWidgetOpenMessageClickParams
* @property {string} context - null
* @property {number} index - null
* @property {GUID} message_id - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout widget-> open message click. Evid: 86.


 * context - Type: string.
 *
 * index - Type: numeric.
 *
 * message_id - Type: guid.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWidgetOpenMessageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWidgetOpenMessageClick = function (params) {
    return { evid: 86, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPackagePickerPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout package picker -> page view. Evid: 41.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutPackagePickerPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPackagePickerPageView = function (params) {
    return { evid: 41, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSenderDetailsClickParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - new,edit
* @property {GUID} uuid - null
**/
/**
 * Name: TE - sender details click. Evid: 250.
 * Event description: click to edit sender details in the TE dashboard page.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: new,edit
 *
 * uuid - Type: guid.
 * @param {teSenderDetailsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSenderDetailsClick = function (params) {
    return { evid: 250, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersAppLoadingParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
* @property {GUID} vsi - visitor session ID
**/
/**
 * Name: get subscribers -> app loading. Evid: 302.
 * Event description: event triggered when the app got called from the server. after server event 36:1012..

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 *
 * vsi - Type: guid. Desc: visitor session ID
 * @param {getSubscribersAppLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersAppLoading = function (params) {
    return { evid: 302, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} sieEditorPanelReturningBannerClickParams
* @property {string} context - null
* @property {GUID} esi - esi
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - shoutout editor panel
* @property {GUID} site_id - site_id for SO in Editor
* @property {number} ts - timespan from session start
* @property {string} type - generic/store
* @property {GUID} uuid - null
* @property {string} viewmode - view_mode
**/
/**
 * Name: SIE Editor panel returning banner-> Click. Evid: 113.
 * Event description: user clicked on the banner.

 * context - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: shoutout editor panel
 *
 * site_id - Type: guid. Desc: site_id for SO in Editor
 *
 * ts - Type: numeric. Desc: timespan from session start
 *
 * type - Type: string. Desc: generic/store
 *
 * uuid - Type: guid.
 *
 * viewmode - Type: string. Desc: view_mode
 * @param {sieEditorPanelReturningBannerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sieEditorPanelReturningBannerClick = function (params) {
    return { evid: 113, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeItemReadyParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} subtype - subtype of the region type
* @property {string} type - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> item ready. Evid: 13.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * subtype - Type: string. Desc: subtype of the region type
 *
 * type - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeItemReadyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeItemReady = function (params) {
    return { evid: 13, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutFilterSelectParams
* @property {string} context - null
* @property {string} filter_type - all, published, drafts, archived
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout my shoutout -> filter select. Evid: 131.
 * Event description: in my shoutout select one of the filters (tabs) : published, drafts and etc.

 * context - Type: string.
 *
 * filter_type - Type: string. Desc: all, published, drafts, archived
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutMyShoutoutFilterSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutFilterSelect = function (params) {
    return { evid: 131, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teDashboardViewParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} sender_details_status - sender details is set or not
* @property {string} sender_page_status - sender details is set or not
* @property {GUID} uuid - null
**/
/**
 * Name: TE - dashboard view. Evid: 259.
 * Event description: open the TE dashboard page view.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * sender_details_status - Type: string. Desc: sender details is set or not
 *
 * sender_page_status - Type: string. Desc: sender details is set or not
 *
 * uuid - Type: guid.
 * @param {teDashboardViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teDashboardView = function (params) {
    return { evid: 259, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} oneAppOpenShoutoutAppRequestParams
* @property {string} action - action: "reuse"/"edit"/"newFromTemplate"
* @property {string} context - null
* @property {GUID} message_id - message_id guid
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: one app - open shoutout app request. Evid: 202.
 * Event description: when user is requested to open shoutout app.

 * action - Type: string. Desc: action: "reuse"/"edit"/"newFromTemplate"
 *
 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message_id guid
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {oneAppOpenShoutoutAppRequestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oneAppOpenShoutoutAppRequest = function (params) {
    return { evid: 202, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teAutoSaveClickParams
* @property {GUID} action_id - action_id
* @property {string} context - context
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {number} number_of_placeholders - number_of_placeholders
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} rule_id - rule_id
* @property {string} subject - the subject in the message
* @property {GUID} template_id - tmeplate id
* @property {GUID} uuid - null
**/
/**
 * Name: TE AUTO - save click. Evid: 273.
 * Event description: in the composer, click on save.

 * action_id - Type: guid. Desc: action_id
 *
 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * number_of_placeholders - Type: numeric. Desc: number_of_placeholders
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * rule_id - Type: guid. Desc: rule_id
 *
 * subject - Type: string. Desc: the subject in the message
 *
 * template_id - Type: guid. Desc: tmeplate id
 *
 * uuid - Type: guid.
 * @param {teAutoSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teAutoSaveClick = function (params) {
    return { evid: 273, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutErrorParams
* @property {string} context - null
* @property {string} error - error description
* @property {number} errorCode - errorCode
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout error. Evid: 176.
 * Event description: general shoutout error.

 * context - Type: string.
 *
 * error - Type: string. Desc: error description
 *
 * errorCode - Type: numeric. Desc: errorCode
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutError = function (params) {
    return { evid: 176, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSidebarResourcesClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout sidebar -> resources  click. Evid: 151.
 * Event description: click on resources   button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSidebarResourcesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSidebarResourcesClick = function (params) {
    return { evid: 151, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} oneAppAppOpenAppstoreParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: one app - app open appstore. Evid: 204.
 * Event description: open shoutout in appstore if app is not installed on user device.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {oneAppAppOpenAppstoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oneAppAppOpenAppstore = function (params) {
    return { evid: 204, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeReturningUserSsmDialogCloseClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose returning user ssm -> dialog  close click. Evid: 141.
 * Event description: close returning-user tips dialog,
returning user dialog view opens when user returning first time and open  composer
ssm - shoutout styling model.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeReturningUserSsmDialogCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeReturningUserSsmDialogCloseClick = function (params) {
    return { evid: 141, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teMessageDetailsModalEditEmailIdParams
* @property {string} context - context - TE
* @property {string} email_id - email_id
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {string} modal_type - published success,code snippets
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - message details modal edit email id. Evid: 253.
 * Event description: edit and save a new value for email id.

 * context - Type: string. Desc: context - TE
 *
 * email_id - Type: string. Desc: email_id
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: published success,code snippets
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teMessageDetailsModalEditEmailIdParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teMessageDetailsModalEditEmailId = function (params) {
    return { evid: 253, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMessageViewParams
* @property {string} context - null
* @property {string} message_name - unique name of the message
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page - the page where the message is shown (dashboard, composer..))
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout - message view. Evid: 336.
 * Event description: Generic event for message view from any page in shoutout.

 * context - Type: string.
 *
 * message_name - Type: string. Desc: unique name of the message
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page - Type: string. Desc: the page where the message is shown (dashboard, composer..))
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutMessageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMessageView = function (params) {
    return { evid: 336, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teEditPublishedWarningNotificationCloseClickParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - edit published warning notification close click. Evid: 258.
 * Event description: when edit a publushed, gets a blue line on th etop with warning, click to close.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teEditPublishedWarningNotificationCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teEditPublishedWarningNotificationCloseClick = function (params) {
    return { evid: 258, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutotuTemplateStartFromScratchParams
* @property {string} context - context
* @property {string} location - top/bottom
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page_name - the name of the page: "dashboard"/"templates"
* @property {string} templatesList - templates list loaded to user in template page - for  impressions
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutotu template -> start from scratch. Evid: 284.
 * Event description: in template page  - click on start from scratch.

 * context - Type: string. Desc: context
 *
 * location - Type: string. Desc: top/bottom
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_name - Type: string. Desc: the name of the page: "dashboard"/"templates"
 *
 * templatesList - Type: string. Desc: templates list loaded to user in template page - for  impressions
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutotuTemplateStartFromScratchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutotuTemplateStartFromScratch = function (params) {
    return { evid: 284, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teOpenComposerParams
* @property {string} components_data - Json with all components data and number of componet
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - referral of open composer
* @property {string} sender_details_status - sender details is set or not
* @property {string} sender_page_status - sender details is set or not
* @property {string} subject - the subject in the message
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE - open composer. Evid: 260.
 * Event description: open the TE composer page view.

 * components_data - Type: string. Desc: Json with all components data and number of componet
 *
 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: referral of open composer
 *
 * sender_details_status - Type: string. Desc: sender details is set or not
 *
 * sender_page_status - Type: string. Desc: sender details is set or not
 *
 * subject - Type: string. Desc: the subject in the message
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teOpenComposerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teOpenComposer = function (params) {
    return { evid: 260, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeItemEditClickParams
* @property {string} context - null
* @property {boolean} is_title - is title region
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - NA
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> item edit click. Evid: 106.
 * Event description: item edit click on stage.

 * context - Type: string.
 *
 * is_title - Type: bool. Desc: is title region
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: NA
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeItemEditClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeItemEditClick = function (params) {
    return { evid: 106, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWidgetNewShoutoutClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} state - null
* @property {string} origin - blank/active
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout widget-> new shoutout click. Evid: 83.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * state - Type: string.
 *
 * origin - Type: string. Desc: blank/active
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWidgetNewShoutoutClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWidgetNewShoutoutClick = function (params) {
    return { evid: 83, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardNewsFeedClickParams
* @property {string} context - opening context
* @property {string} title - news feed title
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package type
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout dashboard -> News Feed Click. Evid: 28.
 * Event description: DASHBOARD_NEWS_FEED_CLICK.

 * context - Type: string. Desc: opening context
 *
 * title - Type: string. Desc: news feed title
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package type
 *
 * uuid - Type: guid.
 * @param {shoutoutDashboardNewsFeedClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardNewsFeedClick = function (params) {
    return { evid: 28, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutOpenParams
* @property {string} context - null
* @property {boolean} is_first - is first time user got to shoutout
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} page_id - na
* @property {string} referral_info - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout -> open. Evid: 76.
 * Event description: shoutout -> open.

 * context - Type: string.
 *
 * is_first - Type: bool. Desc: is first time user got to shoutout
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: guid. Desc: na
 *
 * referral_info - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutOpen = function (params) {
    return { evid: 76, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emPackagePickerCtaClickParams
* @property {string} button_name - button/link name (translation_key)
* @property {string} context - null
* @property {boolean} is_primary_cta - true if click is for the main flow
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - name of the page
* @property {string} package_group - null
* @property {string} package_id - null
* @property {Url} url - url of the button/link
* @property {GUID} uuid - null
**/
/**
 * Name: EM - Package Picker CTA Click. Evid: 383.
 * Event description: any link or button click in EM premium package picker.

 * button_name - Type: string. Desc: button/link name (translation_key)
 *
 * context - Type: string.
 *
 * is_primary_cta - Type: bool. Desc: true if click is for the main flow
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: name of the page
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * url - Type: url. Desc: url of the button/link
 *
 * uuid - Type: guid.
 * @param {emPackagePickerCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emPackagePickerCtaClick = function (params) {
    return { evid: 383, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeInitiateShoutoutTemplateFromBmIntegrationParams
* @property {string} context - context
* @property {string} integrationType - example: use-template/selected-contacts/batch/undefined
* @property {string} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - source from where the users open the composer
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> initiate shoutout template from BM integration. Evid: 350.
 * Event description: When shoutout composer is called via template selection from a BM integration by another vertical.

 * context - Type: string. Desc: context
 *
 * integrationType - Type: string. Desc: example: use-template/selected-contacts/batch/undefined
 *
 * message_id - Type: string. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: source from where the users open the composer
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeInitiateShoutoutTemplateFromBmIntegrationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeInitiateShoutoutTemplateFromBmIntegration = function (params) {
    return { evid: 350, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teNotificationViewParams
* @property {string} context - context (TE/APeS...)
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} notification_name - name of the notification
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE -  notification view. Evid: 343.
 * Event description: generic notificarion view in the composer.

 * context - Type: string. Desc: context (TE/APeS...)
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * notification_name - Type: string. Desc: name of the notification
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teNotificationViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teNotificationView = function (params) {
    return { evid: 343, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostBudgetPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost budget -> page view. Evid: 184.
 * Event description: page view.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostBudgetPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostBudgetPageView = function (params) {
    return { evid: 184, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposePreviewClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> preview click. Evid: 140.
 * Event description: in the in the shoutout compose page click on "preview & test".

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposePreviewClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposePreviewClick = function (params) {
    return { evid: 140, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutouts3DotsActionClickParams
* @property {string} action - send now, pause, duplicate, delete
* @property {string} campaign_source - web/mobile
* @property {string} context - context
* @property {GUID} message_id - if exists
* @property {string} message_type - the label of the post (published, scheduled, etc...)
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page - dashboard,my campaigns
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout -> 3 dots action click. Evid: 295.
 * Event description: click on an action in 3 dots in "my shoutouts" or "dashboard".

 * action - Type: string. Desc: send now, pause, duplicate, delete
 *
 * campaign_source - Type: string. Desc: web/mobile
 *
 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: if exists
 *
 * message_type - Type: string. Desc: the label of the post (published, scheduled, etc...)
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page - Type: string. Desc: dashboard,my campaigns
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutMyShoutouts3DotsActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutouts3DotsActionClick = function (params) {
    return { evid: 295, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersLayoutChangeLayoutParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} name - name: side_layout, below_layout
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers layout - change layout. Evid: 217.
 * Event description: Switching between horizontal/vertical.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name: side_layout, below_layout
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {getSubscribersLayoutChangeLayoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersLayoutChangeLayout = function (params) {
    return { evid: 217, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSavingChangesModalCtaClickParams
* @property {string} context - context - TE
* @property {string} cta_type - cancel,save
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - saving changes modal cta click. Evid: 270.
 * Event description: open a published to edit and click on save you get this modal.

 * context - Type: string. Desc: context - TE
 *
 * cta_type - Type: string. Desc: cancel,save
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teSavingChangesModalCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSavingChangesModalCtaClick = function (params) {
    return { evid: 270, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsRecipientsContactClickParams
* @property {GUID} contact_id - the id of the contact
* @property {string} context - context
* @property {string} filter - "the name of the filter, optional values: Sent/Delivered/opened/clicked/orders/not opened etc..."
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats-> recipients - contact click. Evid: 317.
 * Event description: when the user clicks on a contact for more details.

 * contact_id - Type: guid. Desc: the id of the contact
 *
 * context - Type: string. Desc: context
 *
 * filter - Type: string. Desc: "the name of the filter, optional values: Sent/Delivered/opened/clicked/orders/not opened etc..."
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsRecipientsContactClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsRecipientsContactClick = function (params) {
    return { evid: 317, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} oneAppNoMessagesParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: one app - no messages. Evid: 207.
 * Event description: user has no shotuouts at all (published or drafts).

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {oneAppNoMessagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oneAppNoMessages = function (params) {
    return { evid: 207, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostSetUpNextClickClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost set up -> next click click. Evid: 180.
 * Event description: clicking on next button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostSetUpNextClickClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostSetUpNextClickClick = function (params) {
    return { evid: 180, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWellDoneCopyUrlClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout well done -> copy url click. Evid: 27.
 * Event description: COMPLETE_PAGE_COPY_LINK_CLICK.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWellDoneCopyUrlClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWellDoneCopyUrlClick = function (params) {
    return { evid: 27, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposerModalViewParams
* @property {string} context - context
* @property {string} message_id - if exists
* @property {string} ml_translation_language - null
* @property {string} modal_type - the type of the modal (new composer update))
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout composer -> modal view. Evid: 305.
 * Event description: any modal that is been opened in the composer page (we are stopping using this event, and instead we will use the generic one 298).

 * context - Type: string. Desc: context
 *
 * message_id - Type: string. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: the type of the modal (new composer update))
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutComposerModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposerModalView = function (params) {
    return { evid: 305, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPreviewAndTestPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} page_id - na
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout preview and test -> page view. Evid: 108.
 * Event description: test and preview.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: guid. Desc: na
 *
 * uuid - Type: guid.
 * @param {shoutoutPreviewAndTestPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPreviewAndTestPageView = function (params) {
    return { evid: 108, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutHtmlViewIntroductionModalParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout html -> view introduction modal. Evid: 276.
 * Event description: view the introduction modal of html - once per metasite.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutHtmlViewIntroductionModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutHtmlViewIntroductionModal = function (params) {
    return { evid: 276, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} tePublishClickParams
* @property {string} context - context - TE
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {number} number_of_placeholders - number_of_placeholders
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} subject - subject
* @property {GUID} uuid - null
**/
/**
 * Name: TE - publish click. Evid: 265.
 * Event description: click on save and publish.

 * context - Type: string. Desc: context - TE
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * number_of_placeholders - Type: numeric. Desc: number_of_placeholders
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * subject - Type: string. Desc: subject
 *
 * uuid - Type: guid.
 * @param {tePublishClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tePublishClick = function (params) {
    return { evid: 265, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutStatsClickParams
* @property {string} campaign_source - web/mobile
* @property {string} context - null
* @property {GUID} message_id - message id
* @property {string} message_type - the label of the post (published, scheduled, etc...)
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - icon, card, toast
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page - dashboard, my campaigns
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout my shoutout-> stats click. Evid: 135.
 * Event description: in my shoutout, on one of the SO items click on "stats" to open statistical page.

 * campaign_source - Type: string. Desc: web/mobile
 *
 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message id
 *
 * message_type - Type: string. Desc: the label of the post (published, scheduled, etc...)
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: icon, card, toast
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page - Type: string. Desc: dashboard, my campaigns
 *
 * uuid - Type: guid.
 * @param {shoutoutMyShoutoutStatsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutStatsClick = function (params) {
    return { evid: 135, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutOnboardingNextClickParams
* @property {string} context - null
* @property {string} current_step - current step in onboarding flow
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout onboarding -> next click. Evid: 174.
 * Event description: click on next
when user goes on the onboarding flow. Onboarding is for new users (4 GIFS, one after another).

 * context - Type: string.
 *
 * current_step - Type: string. Desc: current step in onboarding flow
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutOnboardingNextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutOnboardingNextClick = function (params) {
    return { evid: 174, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostCongratsMySoClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost congrats-> my so click. Evid: 197.
 * Event description: clicking on my so link.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostCongratsMySoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostCongratsMySoClick = function (params) {
    return { evid: 197, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostPreviewPreviewNextClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost preview -> preview next click. Evid: 183.
 * Event description: clicking on next button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostPreviewPreviewNextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostPreviewPreviewNextClick = function (params) {
    return { evid: 183, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerAssistanceWelcomePopoverCtaClickParams
* @property {string} context - context
* @property {string} cta_type - cta name - lets go
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer - assistance welcome  popover cta click. Evid: 326.
 * Event description: welcome assistance popover is opened, clicl on the cta to start.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: cta name - lets go
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerAssistanceWelcomePopoverCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerAssistanceWelcomePopoverCtaClick = function (params) {
    return { evid: 326, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeItemPropertyEditClickParams
* @property {string} context - context
* @property {string} interaction_type - How the user edited the property. Slider, input, toggle, drop-down, etc.
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} panel_type - panel_type
* @property {string} property - bold, underline, color....
* @property {string} property_value - value of the property , or for toggle actions (remove /add )
* @property {GUID} regionId - ID of the region that had a property change
* @property {string} tab - tab
* @property {string} type - item type  - text, button, link, background, inner background
* @property {string} user_define - custom, offering
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> item property edit click. Evid: 275.
 * Event description: when edit the text click on one of the item options like bold, directions .....

 * context - Type: string. Desc: context
 *
 * interaction_type - Type: string. Desc: How the user edited the property. Slider, input, toggle, drop-down, etc.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * panel_type - Type: string. Desc: panel_type
 *
 * property - Type: string. Desc: bold, underline, color....
 *
 * property_value - Type: string. Desc: value of the property , or for toggle actions (remove /add )
 *
 * regionId - Type: guid. Desc: ID of the region that had a property change
 *
 * tab - Type: string. Desc: tab
 *
 * type - Type: string. Desc: item type  - text, button, link, background, inner background
 *
 * user_define - Type: string. Desc: custom, offering
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeItemPropertyEditClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeItemPropertyEditClick = function (params) {
    return { evid: 275, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersSettingsFormMobileSwitchParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {boolean} status - true:On, false:Off
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers settings - form mobile switch. Evid: 212.
 * Event description: Choosing whether to display phone field.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * status - Type: bool. Desc: true:On, false:Off
 *
 * uuid - Type: guid.
 * @param {getSubscribersSettingsFormMobileSwitchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersSettingsFormMobileSwitch = function (params) {
    return { evid: 212, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} sieWelcomePanelGetStartedClickParams
* @property {string} context - null
* @property {GUID} esi - esi
* @property {boolean} shoutout_user - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - shoutout editor panel
* @property {GUID} site_id - site_id for SO in Editor
* @property {number} ts - ts
* @property {GUID} uuid - null
* @property {string} viewmode - view_mode
**/
/**
 * Name: SIE Welcome panel get started-> Click. Evid: 111.
 * Event description: when user clicks on the getting started button in the welcome panel.

 * context - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * shoutout_user - Type: bool.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: shoutout editor panel
 *
 * site_id - Type: guid. Desc: site_id for SO in Editor
 *
 * ts - Type: numeric. Desc: ts
 *
 * uuid - Type: guid.
 *
 * viewmode - Type: string. Desc: view_mode
 * @param {sieWelcomePanelGetStartedClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sieWelcomePanelGetStartedClick = function (params) {
    return { evid: 111, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teTextComponentDynamicVariableModalAddClickParams
* @property {string} context - context - TE
* @property {string} fallback_value - fallback value
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - text-region/subject
* @property {GUID} uuid - null
* @property {string} variable_name - variable value
**/
/**
 * Name: composer - text component dynamic variable modal add click. Evid: 245.
 * Event description: save and close the modal.

 * context - Type: string. Desc: context - TE
 *
 * fallback_value - Type: string. Desc: fallback value
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: text-region/subject
 *
 * uuid - Type: guid.
 *
 * variable_name - Type: string. Desc: variable value
 * @param {teTextComponentDynamicVariableModalAddClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teTextComponentDynamicVariableModalAddClick = function (params) {
    return { evid: 245, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardAscendQuotaWidgetLoadParams
* @property {number} campaign_quota_total - total number of campaigns in user's quota. 1,000,000 for unlimited
* @property {number} campaign_quota_used - number of campaigns already used from user's quota in current cycle
* @property {string} context - null
* @property {number} email_quota_total - total number of email recipients in user's quota. 1,000,000 for unlimited
* @property {number} email_quota_used - number of email recipients already used from user's quota in current cycle
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout dashboard -> ascend quota widget load. Evid: 348.
 * Event description: in the email marketing dashboard - keep track of user's email quota when the widget loads.

 * campaign_quota_total - Type: numeric. Desc: total number of campaigns in user's quota. 1,000,000 for unlimited
 *
 * campaign_quota_used - Type: numeric. Desc: number of campaigns already used from user's quota in current cycle
 *
 * context - Type: string.
 *
 * email_quota_total - Type: numeric. Desc: total number of email recipients in user's quota. 1,000,000 for unlimited
 *
 * email_quota_used - Type: numeric. Desc: number of email recipients already used from user's quota in current cycle
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutDashboardAscendQuotaWidgetLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardAscendQuotaWidgetLoad = function (params) {
    return { evid: 348, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPanelPanelItemCtaClickParams
* @property {string} context - context
* @property {string} cta_type - cancel, apply, add vairiable
* @property {string} item - item under each panel type (footer settings,inner background,outer backgrounf settings,text...), None
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} panel_type - add an item, style, background,
* @property {string} tab - Design, Style, Content, none
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout panel - > panel item cta click. Evid: 287.
 * Event description: when a new type of panel is loaded.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: cancel, apply, add vairiable
 *
 * item - Type: string. Desc: item under each panel type (footer settings,inner background,outer backgrounf settings,text...), None
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * panel_type - Type: string. Desc: add an item, style, background,
 *
 * tab - Type: string. Desc: Design, Style, Content, none
 *
 * uuid - Type: guid.
 * @param {shoutoutPanelPanelItemCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPanelPanelItemCtaClick = function (params) {
    return { evid: 287, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutMoveToArchiveParams
* @property {string} context - null
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout my shoutout -> move to archive. Evid: 133.
 * Event description: in my shoutout , on one of the SO items click on "move to archive".

 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutMyShoutoutMoveToArchiveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutMoveToArchive = function (params) {
    return { evid: 133, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsAddContactsButtonParams
* @property {string} context - null
* @property {number} count - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout contacts -> add contacts button. Evid: 21.


 * context - Type: string.
 *
 * count - Type: numeric.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutContactsAddContactsButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsAddContactsButton = function (params) {
    return { evid: 21, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeInitiateShoutoutTemplateParams
* @property {string} context - context
* @property {string} integrationType - example:  use-template/selected-contacts/batch/undefined
* @property {string} messageId - the message id if exists in cases of old integrations
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - source from where the users open the composer
* @property {string} tags - tags injected in composer
* @property {string} template_id - template_id
* @property {string} template_name - template_name
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> initiate shoutout template. Evid: 285.
 * Event description: when clicking on template for open composer, this event will include the template data for cases the composer event 11 cant load it....

 * context - Type: string. Desc: context
 *
 * integrationType - Type: string. Desc: example:  use-template/selected-contacts/batch/undefined
 *
 * messageId - Type: string. Desc: the message id if exists in cases of old integrations
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: source from where the users open the composer
 *
 * tags - Type: string. Desc: tags injected in composer
 *
 * template_id - Type: string. Desc: template_id
 *
 * template_name - Type: string. Desc: template_name
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeInitiateShoutoutTemplateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeInitiateShoutoutTemplate = function (params) {
    return { evid: 285, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersSubscribeClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers -> subscribe click. Evid: 300.
 * Event description: when users clicked "subscribe".

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {getSubscribersSubscribeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersSubscribeClick = function (params) {
    return { evid: 300, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersSettingsFormTitleCheckboxClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {boolean} status - true:On, false:Off
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers settings - form title checkbox click. Evid: 215.
 * Event description: Hiding/Showing title.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * status - Type: bool. Desc: true:On, false:Off
 *
 * uuid - Type: guid.
 * @param {getSubscribersSettingsFormTitleCheckboxClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersSettingsFormTitleCheckboxClick = function (params) {
    return { evid: 215, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutEmailVerificationExplanationViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout email verification-> explanation view. Evid: 155.
 * Event description: Showing email verification lightbox after user click on send button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutEmailVerificationExplanationViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutEmailVerificationExplanationView = function (params) {
    return { evid: 155, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersDesignChangeTemplateParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} name - name: Classic, Strip, Postcard, Elegant, Headiine
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers design - change template. Evid: 219.
 * Event description: Switching between templates (styles).

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name: Classic, Strip, Postcard, Elegant, Headiine
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {getSubscribersDesignChangeTemplateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersDesignChangeTemplate = function (params) {
    return { evid: 219, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emMessageCtaClickParams
* @property {string} action - action value
* @property {string} context - context
* @property {string} cta_name - name of the message/banner/CTA/pop-up, same as 36:40
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: EM - Message CTA Click. Evid: 64.
 * Event description: Action made by the user in EM - Message Shown.

 * action - Type: string. Desc: action value
 *
 * context - Type: string. Desc: context
 *
 * cta_name - Type: string. Desc: name of the message/banner/CTA/pop-up, same as 36:40
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {emMessageCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emMessageCtaClick = function (params) {
    return { evid: 64, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostPaymentPageViewParams
* @property {string} adAccountId - adAccountId
* @property {number} budget - budget
* @property {string} context - null
* @property {number} cpa - cpa
* @property {number} cpm - cpm
* @property {string} currency - currency
* @property {boolean} customAudienceIncluded - customAudienceIncluded
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {boolean} optimizeForClicks - optimize_for_clicks
* @property {string} package_group - null
* @property {string} package_id - null
* @property {number} reachByBudgetMax - reach_by_budgetmin
* @property {number} reachByBudgetMin - reachByBudgetMin
* @property {number} reachMax - reachMax
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost payment -> page view. Evid: 189.
 * Event description: page view.

 * adAccountId - Type: string. Desc: adAccountId
 *
 * budget - Type: numeric. Desc: budget
 *
 * context - Type: string.
 *
 * cpa - Type: numeric. Desc: cpa
 *
 * cpm - Type: numeric. Desc: cpm
 *
 * currency - Type: string. Desc: currency
 *
 * customAudienceIncluded - Type: bool. Desc: customAudienceIncluded
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * optimizeForClicks - Type: bool. Desc: optimize_for_clicks
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * reachByBudgetMax - Type: numeric. Desc: reach_by_budgetmin
 *
 * reachByBudgetMin - Type: numeric. Desc: reachByBudgetMin
 *
 * reachMax - Type: numeric. Desc: reachMax
 *
 * uuid - Type: guid.
 * @param {fbBoostPaymentPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostPaymentPageView = function (params) {
    return { evid: 189, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSubjectLineClickParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE - subject line click. Evid: 247.
 * Event description: click to edit the subject line (input is in focus).

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teSubjectLineClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSubjectLineClick = function (params) {
    return { evid: 247, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emComposerUndoRedoActionsParams
* @property {string} action - Undo/Redo
* @property {string} context - null
* @property {GUID} message_id - Sometimes can be null if the user completes actions and undoes/redoes them faster than we can save the message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: EM Composer - Undo/Redo Actions. Evid: 388.
 * Event description: Event for any Undo/Redo action in the Email Marketing Composer.

 * action - Type: string. Desc: Undo/Redo
 *
 * context - Type: string.
 *
 * message_id - Type: guid. Desc: Sometimes can be null if the user completes actions and undoes/redoes them faster than we can save the message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {emComposerUndoRedoActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emComposerUndoRedoActions = function (params) {
    return { evid: 388, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutTemplatesDynamicTemplateOnProcessDoneParams
* @property {string} context - shoutout/sosa
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {string} template_list_name - list name(BO) || top/bottom
* @property {string} template_name - template_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout templates -> dynamic template on process done. Evid: 224.
 * Event description: templates - choosing a template.

 * context - Type: string. Desc: shoutout/sosa
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * template_list_name - Type: string. Desc: list name(BO) || top/bottom
 *
 * template_name - Type: string. Desc: template_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutTemplatesDynamicTemplateOnProcessDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutTemplatesDynamicTemplateOnProcessDone = function (params) {
    return { evid: 224, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardShoutoutDraftEditParams
* @property {string} context - null
* @property {GUID} message_id - message_id
* @property {string} messages_type - draft/published
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout dashboard->shoutout draft edit. Evid: 79.
 * Event description: shoutout draft edit.

 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message_id
 *
 * messages_type - Type: string. Desc: draft/published
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutDashboardShoutoutDraftEditParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardShoutoutDraftEdit = function (params) {
    return { evid: 79, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardShareButtonParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
* @property {string} value - na
**/
/**
 * Name: shoutout dashboard-> share button. Evid: 69.
 * Event description: event for so db share button , has been ignored till now.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 *
 * value - Type: string. Desc: na
 * @param {shoutoutDashboardShareButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardShareButton = function (params) {
    return { evid: 69, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutQuotaUpgradeParams
* @property {string} context - null
* @property {number} last_quota - the quota before the change
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} new_package_group - the new package group the site bought
* @property {string} new_package_name - the new package name the site bought
* @property {number} new_quota - the quota after the change
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} prev_package_group - the package group the site had before the upgrade
* @property {string} prev_package_name - the package name the site had before the upgrade
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout quota upgrade. Evid: 310.
 * Event description: when the quata of the user has changed by premium purchase.

 * context - Type: string.
 *
 * last_quota - Type: numeric. Desc: the quota before the change
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * new_package_group - Type: string. Desc: the new package group the site bought
 *
 * new_package_name - Type: string. Desc: the new package name the site bought
 *
 * new_quota - Type: numeric. Desc: the quota after the change
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * prev_package_group - Type: string. Desc: the package group the site had before the upgrade
 *
 * prev_package_name - Type: string. Desc: the package name the site had before the upgrade
 *
 * uuid - Type: guid.
 * @param {shoutoutQuotaUpgradeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutQuotaUpgrade = function (params) {
    return { evid: 310, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposePageViewParams
* @property {string} campaign_source - web/mobile
* @property {string} context - null
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - source from where the users open the composer
* @property {string} tags - tags injected in composer
* @property {string} template_id - template_id
* @property {string} template_name - template_name
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> page view. Evid: 11.


 * campaign_source - Type: string. Desc: web/mobile
 *
 * context - Type: string.
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: source from where the users open the composer
 *
 * tags - Type: string. Desc: tags injected in composer
 *
 * template_id - Type: string. Desc: template_id
 *
 * template_name - Type: string. Desc: template_name
 *
 * uuid - Type: guid.
 * @param {shoutoutComposePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposePageView = function (params) {
    return { evid: 11, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} oneAppShowLandingPageParams
* @property {string} context - null
* @property {GUID} message_id - message_id guid
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: one app - show landing page. Evid: 201.
 * Event description: when user watching an exiting shoutout.

 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message_id guid
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {oneAppShowLandingPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oneAppShowLandingPage = function (params) {
    return { evid: 201, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardCloseTheLoopStatsLoadedParams
* @property {string} card_values - json, (e.g. Orders:number of orders, revenue:amount of revenue, bookings:number of bookings etc.)
* @property {string} context - context
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - ascend package group
* @property {string} package_id - ascend package name
* @property {string} page - which page stats were loaded in (dashboard / my campaigns / stats)
* @property {DateTime} published_on_date - timestamp on which message was published
* @property {string} template_id - template_id
* @property {GUID} uuid - user_id
**/
/**
 * Name: shoutout dashboard -> close the loop stats loaded. Evid: 352.
 * Event description: when campaign's close the loop stats are loaded on a campaign card. Note that in the case of no data (0 orders, 0 revenue or 0 unique visitors this event will not be fired).

 * card_values - Type: string. Desc: json, (e.g. Orders:number of orders, revenue:amount of revenue, bookings:number of bookings etc.)
 *
 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: ascend package group
 *
 * package_id - Type: string. Desc: ascend package name
 *
 * page - Type: string. Desc: which page stats were loaded in (dashboard / my campaigns / stats)
 *
 * published_on_date - Type: datetime. Desc: timestamp on which message was published
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid. Desc: user_id
 * @param {shoutoutDashboardCloseTheLoopStatsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardCloseTheLoopStatsLoaded = function (params) {
    return { evid: 352, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} headerNextClickParams
* @property {string} context - null
* @property {number} count - count
* @property {string} current - currentPage
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} template_name - template_name
* @property {GUID} uuid - null
**/
/**
 * Name: Header Next click. Evid: 98.
 * Event description: Header next click.

 * context - Type: string.
 *
 * count - Type: numeric. Desc: count
 *
 * current - Type: string. Desc: currentPage
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * template_name - Type: string. Desc: template_name
 *
 * uuid - Type: guid.
 * @param {headerNextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var headerNextClick = function (params) {
    return { evid: 98, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSidebarMyShoutoutClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout sidebar -> my shoutout click. Evid: 150.
 * Event description: click on my shoutout button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSidebarMyShoutoutClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSidebarMyShoutoutClick = function (params) {
    return { evid: 150, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutEligibilityForFirstTimeExpParams
* @property {string} context - context
* @property {string} experience - which first time experience user is eligible for
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout -> eligibility for first time exp. Evid: 360.
 * Event description: When user opens shoutout dashboard while being eligible for first time experience.

 * context - Type: string. Desc: context
 *
 * experience - Type: string. Desc: which first time experience user is eligible for
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutEligibilityForFirstTimeExpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutEligibilityForFirstTimeExp = function (params) {
    return { evid: 360, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shotuoutComplianceArticleLinkClickParams
* @property {string} article_link_name - Spam_complaints / spam_traps / bounces / low_engagement / read_more
* @property {string} compliance_status - Warned / suspended / banned (from server)
* @property {string} context -
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group -
* @property {string} package_id -
* @property {string} page_name - from which page of the compliance
* @property {string} reason - Spam_complaints / spam_traps / bounces / low_engagement / vetting - from server
* @property {GUID} uuid -
**/
/**
 * Name: shotuout compliance - article link click. Evid: 218.
 * Event description: click on the article link.

 * article_link_name - Type: string. Desc: Spam_complaints / spam_traps / bounces / low_engagement / read_more
 *
 * compliance_status - Type: string. Desc: Warned / suspended / banned (from server)
 *
 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_name - Type: string. Desc: from which page of the compliance
 *
 * reason - Type: string. Desc: Spam_complaints / spam_traps / bounces / low_engagement / vetting - from server
 *
 * uuid - Type: guid.
 * @param {shotuoutComplianceArticleLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shotuoutComplianceArticleLinkClick = function (params) {
    return { evid: 218, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emPackagePickerCheckoutPageParams
* @property {string} button_location - where was the button that lead to PP (source comes from 36:377)
* @property {string} button_name - button name that lead to PP (source comes from 36:377)
* @property {string} context - null
* @property {string} cycleName - selected EM premium package cycle
* @property {string} em_premium_status - current EM premium package + cycle
* @property {boolean} is_sale - Flag that defines if the users PP is with a sale
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - where the page was opened from (source comes from 36:377)
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} package_name - selected EM package name
* @property {GUID} uuid - null
**/
/**
 * Name: EM - Package Picker Checkout Page. Evid: 381.
 * Event description: EM  Package Picker Checkout Page Opened (page shown).

 * button_location - Type: string. Desc: where was the button that lead to PP (source comes from 36:377)
 *
 * button_name - Type: string. Desc: button name that lead to PP (source comes from 36:377)
 *
 * context - Type: string.
 *
 * cycleName - Type: string. Desc: selected EM premium package cycle
 *
 * em_premium_status - Type: string. Desc: current EM premium package + cycle
 *
 * is_sale - Type: bool. Desc: Flag that defines if the users PP is with a sale
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: where the page was opened from (source comes from 36:377)
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * package_name - Type: string. Desc: selected EM package name
 *
 * uuid - Type: guid.
 * @param {emPackagePickerCheckoutPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emPackagePickerCheckoutPage = function (params) {
    return { evid: 381, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shotuoutComplianceCtsClickParams
* @property {string} compliance_status - Warned / suspended / banned (from server)
* @property {string} context -
* @property {string} cta_type - reactivate/contact us/ view tickets/questioner/submit
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group -
* @property {string} package_id -
* @property {string} page_name - from which page of the compliance
* @property {string} reason - Spam_complaints / spam_traps / bounces / low_engagement / vetting - from server
* @property {GUID} uuid -
**/
/**
 * Name: shotuout compliance - CTS click. Evid: 220.
 * Event description: click one one of the CTAs.

 * compliance_status - Type: string. Desc: Warned / suspended / banned (from server)
 *
 * context - Type: string.
 *
 * cta_type - Type: string. Desc: reactivate/contact us/ view tickets/questioner/submit
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_name - Type: string. Desc: from which page of the compliance
 *
 * reason - Type: string. Desc: Spam_complaints / spam_traps / bounces / low_engagement / vetting - from server
 *
 * uuid - Type: guid.
 * @param {shotuoutComplianceCtsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shotuoutComplianceCtsClick = function (params) {
    return { evid: 220, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutNotificationAllowNotificationParams
* @property {boolean} allowNotification - yes/no
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout notification -> allow notification. Evid: 95.
 * Event description: present notification dialog.

 * allowNotification - Type: bool. Desc: yes/no
 *
 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutNotificationAllowNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutNotificationAllowNotification = function (params) {
    return { evid: 95, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutFirstTimeCloseParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout -> first time close. Evid: 17.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutFirstTimeCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutFirstTimeClose = function (params) {
    return { evid: 17, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teHelpIconClickParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} sender_details_status - verified/unverified
* @property {GUID} uuid - null
**/
/**
 * Name: TE - help icon click. Evid: 263.
 * Event description: click on the 'find out how' (help icon) mark in the lower right side of the screan.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * sender_details_status - Type: string. Desc: verified/unverified
 *
 * uuid - Type: guid.
 * @param {teHelpIconClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teHelpIconClick = function (params) {
    return { evid: 263, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWidgetErrorViewParams
* @property {string} context - null
* @property {number} error_code - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout widget-> error view. Evid: 82.


 * context - Type: string.
 *
 * error_code - Type: numeric.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWidgetErrorViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWidgetErrorView = function (params) {
    return { evid: 82, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutHtmlNotificationModalLearnMoreClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout html ->  notification modal learn more click. Evid: 281.
 * Event description: click on the learn more button on the modal.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutHtmlNotificationModalLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutHtmlNotificationModalLearnMoreClick = function (params) {
    return { evid: 281, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageChooseSubjectVariableValueParams
* @property {string} context - context
* @property {boolean} is_resend - was action performed in resend to non-openers flow
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - uuid
* @property {string} variable_name - variable_name
**/
/**
 * Name: shoutout send page -> choose subject variable value. Evid: 309.
 * Event description: beside the subject line, click on the cta to add a variable , a list of options will be opened, and then the users choose a variable type.

 * context - Type: string. Desc: context
 *
 * is_resend - Type: bool. Desc: was action performed in resend to non-openers flow
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * variable_name - Type: string. Desc: variable_name
 * @param {shoutoutSendPageChooseSubjectVariableValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageChooseSubjectVariableValue = function (params) {
    return { evid: 309, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emPackagePickerFaqClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} name - name of the FAQ article (translation_key)
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: EM - Package Picker FAQ Click. Evid: 384.
 * Event description: EM Premium Package Picker FAQ accordion click.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * name - Type: string. Desc: name of the FAQ article (translation_key)
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {emPackagePickerFaqClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emPackagePickerFaqClick = function (params) {
    return { evid: 384, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsDownloadCtaParams
* @property {number} contact_count - contact count in the list being downloaded
* @property {string} context - context
* @property {string} filter_name - null
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats - download cta. Evid: 16.
 * Event description: when the user clicks on "download" in email recipients screen.

 * contact_count - Type: numeric. Desc: contact count in the list being downloaded
 *
 * context - Type: string. Desc: context
 *
 * filter_name - Type: string.
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsDownloadCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsDownloadCta = function (params) {
    return { evid: 16, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teTextComponentDynamicVariableModalCloseParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - text-region/subject
* @property {GUID} uuid - null
**/
/**
 * Name: TE - text component dynamic variable modal close. Evid: 243.
 * Event description: close the dynamic variable.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: text-region/subject
 *
 * uuid - Type: guid.
 * @param {teTextComponentDynamicVariableModalCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teTextComponentDynamicVariableModalClose = function (params) {
    return { evid: 243, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teComposerDynamicVariableModalCtaParams
* @property {string} context - context (TE/APeS...)
* @property {string} cta_type - cta name (e.g save)
* @property {string} ml_translation_language - null
* @property {string} modal_type - type of the modal(e.g Subject and preview)
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE - composer dynamic variable modal CTA. Evid: 339.
 * Event description: dynamic variable modal view click.

 * context - Type: string. Desc: context (TE/APeS...)
 *
 * cta_type - Type: string. Desc: cta name (e.g save)
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: type of the modal(e.g Subject and preview)
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teComposerDynamicVariableModalCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teComposerDynamicVariableModalCta = function (params) {
    return { evid: 339, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageModalClickParams
* @property {string} context - context
* @property {string} cta_type - cancel try again
* @property {string} ml_translation_language - null
* @property {string} modal_type - the name of the modal, example "error modal"
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout send page -> modal click. Evid: 294.
 * Event description: click in the modal in the send page.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: cancel try again
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: the name of the modal, example "error modal"
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutSendPageModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageModalClick = function (params) {
    return { evid: 294, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSidebarDashboardClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout sidebar -> dashboard click. Evid: 148.
 * Event description: click on the dashboard button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSidebarDashboardClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSidebarDashboardClick = function (params) {
    return { evid: 148, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutTemplatesMakeItYoursClickParams
* @property {string} context -
* @property {string} ml_translation_language - null
* @property {GUID} msid -
* @property {string} origin - dashboard/template page
* @property {string} package_group -
* @property {string} package_id -
* @property {GUID} page_id - na
* @property {string} template_id - template_id
* @property {number} template_index - start from 0 - more per category
* @property {string} template_list_name - list name(BO) || top/bottom
* @property {string} template_name - na
* @property {string} template_type - dynamic/static
* @property {GUID} uuid -
**/
/**
 * Name: shoutout templates -> use template. Evid: 59.
 * Event description: templates - choosing a template.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: dashboard/template page
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: guid. Desc: na
 *
 * template_id - Type: string. Desc: template_id
 *
 * template_index - Type: numeric. Desc: start from 0 - more per category
 *
 * template_list_name - Type: string. Desc: list name(BO) || top/bottom
 *
 * template_name - Type: string. Desc: na
 *
 * template_type - Type: string. Desc: dynamic/static
 *
 * uuid - Type: guid.
 * @param {shoutoutTemplatesMakeItYoursClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutTemplatesMakeItYoursClick = function (params) {
    return { evid: 59, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWellDoneShareButtonParams
* @property {string} context - null
* @property {boolean} is_resend - was action performed in resend to non-openers flow
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
* @property {string} value - null
**/
/**
 * Name: shoutout well done -> share button. Evid: 51.


 * context - Type: string.
 *
 * is_resend - Type: bool. Desc: was action performed in resend to non-openers flow
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 *
 * value - Type: string.
 * @param {shoutoutWellDoneShareButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWellDoneShareButton = function (params) {
    return { evid: 51, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} senderDetailsPublicDomainValidationMessageCtaClickParams
* @property {string} context - null
* @property {string} cta_type - purchace mail box
* @property {string} domain - the domain that triggered the message
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - the app which the feature was opened from
* @property {GUID} uuid - uuid
**/
/**
 * Name: sender details - public domain validation message cta click. Evid: 236.
 * Event description: click on the message cta for purchace mail box.

 * context - Type: string.
 *
 * cta_type - Type: string. Desc: purchace mail box
 *
 * domain - Type: string. Desc: the domain that triggered the message
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: the app which the feature was opened from
 *
 * uuid - Type: guid. Desc: uuid
 * @param {senderDetailsPublicDomainValidationMessageCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var senderDetailsPublicDomainValidationMessageCtaClick = function (params) {
    return { evid: 236, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} domainAuthenticationModalViewParams
* @property {string} context - context
* @property {string} domain_authentication_status - authenticated / not authenticated
* @property {string} loadStatus - success / fail
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: domain authentication - modal view. Evid: 363.
 * Event description: When user views domain authentication modal.

 * context - Type: string. Desc: context
 *
 * domain_authentication_status - Type: string. Desc: authenticated / not authenticated
 *
 * loadStatus - Type: string. Desc: success / fail
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {domainAuthenticationModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var domainAuthenticationModalView = function (params) {
    return { evid: 363, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutTestSendTestEmailParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} page_id - NA
* @property {string} source - NA
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout test -> send test email. Evid: 109.
 * Event description: click on send on the send test popup.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: guid. Desc: NA
 *
 * source - Type: string. Desc: NA
 *
 * uuid - Type: guid.
 * @param {shoutoutTestSendTestEmailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutTestSendTestEmail = function (params) {
    return { evid: 109, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSidebarHelpClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout sidebar -> help click. Evid: 149.
 * Event description: click on help icon.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSidebarHelpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSidebarHelpClick = function (params) {
    return { evid: 149, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} tipsLightboxViewedParams
* @property {string} context - null
* @property {boolean} is_shoutout_premium - is_shoutout_premium
* @property {boolean} is_wix_premium - is_wix_premium
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {number} number_of_contacts - number_of_contacts the user tried to send to
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: tips lightbox viewed. Evid: 116.
 * Event description: event is triggered when the lightbox opened in shoutout contacts page, giving qty limitation for the number of contacts..

 * context - Type: string.
 *
 * is_shoutout_premium - Type: bool. Desc: is_shoutout_premium
 *
 * is_wix_premium - Type: bool. Desc: is_wix_premium
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * number_of_contacts - Type: numeric. Desc: number_of_contacts the user tried to send to
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {tipsLightboxViewedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tipsLightboxViewed = function (params) {
    return { evid: 116, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposerSwitchTabsParams
* @property {string} context - null
* @property {string} itemType - item type  - text, button, link, background, inner background
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} tab - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout composer - switch tabs. Evid: 349.
 * Event description: when the user switches between the Content and the Design tabs of an element in the composer.

 * context - Type: string.
 *
 * itemType - Type: string. Desc: item type  - text, button, link, background, inner background
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * tab - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutComposerSwitchTabsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposerSwitchTabs = function (params) {
    return { evid: 349, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutVideoVideoPlayClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout video -> video play click. Evid: 87.
 * Event description: When user clicking 'play' button on video widget.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutVideoVideoPlayClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutVideoVideoPlayClick = function (params) {
    return { evid: 87, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeReturningUserSsmDialogViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose returning user ssm -> dialog  view. Evid: 143.
 * Event description: Showing the returning-user tips dialog
returning user dialog view opens when user returning first time and open  composer
ssm - shoutout styling model.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeReturningUserSsmDialogViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeReturningUserSsmDialogView = function (params) {
    return { evid: 143, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teLeaveEditModeModalViewParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - leave edit mode modal view. Evid: 255.
 * Event description: when leaving in the middle of editing a published, gets a warning message modal.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teLeaveEditModeModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teLeaveEditModeModalView = function (params) {
    return { evid: 255, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSenderDetailsMissingModalViewParams
* @property {string} context - context - TE
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - sender details missing modal view. Evid: 266.
 * Event description: when click on save and published and sender details is not set we get this modal.

 * context - Type: string. Desc: context - TE
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teSenderDetailsMissingModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSenderDetailsMissingModalView = function (params) {
    return { evid: 266, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageEmailValidationViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} raw_result - raw result of validation
* @property {string} result - result
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page email validation->  view. Evid: 161.
 * Event description: Checking email validation.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * raw_result - Type: string. Desc: raw result of validation
 *
 * result - Type: string. Desc: result
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageEmailValidationViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageEmailValidationView = function (params) {
    return { evid: 161, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teComposerComponentCtaClickParams
* @property {string} component_name - component name
* @property {string} context - context (TE/APeS...)
* @property {string} cta_type - cta_type
* @property {boolean} is_title - is title region
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {string} template_id - template id
* @property {GUID} uuid - uuid
**/
/**
 * Name: TE - composer component CTA click. Evid: 346.
 * Event description: when the user click on a CTA in one of the component in the composer.

 * component_name - Type: string. Desc: component name
 *
 * context - Type: string. Desc: context (TE/APeS...)
 *
 * cta_type - Type: string. Desc: cta_type
 *
 * is_title - Type: bool. Desc: is title region
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {teComposerComponentCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teComposerComponentCtaClick = function (params) {
    return { evid: 346, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPanelPanelViewParams
* @property {string} context - context
* @property {string} item - item under each panel type (footer settings,inner background,outer backgrounf settings,text...), None
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} panel_type - add an item, style, background,
* @property {boolean} site_theme_available - true / false
* @property {string} tab - Design, Style, Content, none
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout panel - > panel view. Evid: 286.
 * Event description: when a new type of panel is loaded.

 * context - Type: string. Desc: context
 *
 * item - Type: string. Desc: item under each panel type (footer settings,inner background,outer backgrounf settings,text...), None
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * panel_type - Type: string. Desc: add an item, style, background,
 *
 * site_theme_available - Type: bool. Desc: true / false
 *
 * tab - Type: string. Desc: Design, Style, Content, none
 *
 * uuid - Type: guid.
 * @param {shoutoutPanelPanelViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPanelPanelView = function (params) {
    return { evid: 286, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutResendIconTooltipShowParams
* @property {string} context - context
* @property {string} message - tooltip message
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout  -> resend icon tooltip show. Evid: 357.
 * Event description: when user hovers over greyed out resend icon on the campaign card.

 * context - Type: string. Desc: context
 *
 * message - Type: string. Desc: tooltip message
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutResendIconTooltipShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutResendIconTooltipShow = function (params) {
    return { evid: 357, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutShareClickParams
* @property {string} context - null
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
* @property {string} value - selected share option
**/
/**
 * Name: shoutout my shoutout -> share click. Evid: 134.
 * Event description: in my shoutout, on one of the SO items click on one of the share options.

 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 *
 * value - Type: string. Desc: selected share option
 * @param {shoutoutMyShoutoutShareClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutShareClick = function (params) {
    return { evid: 134, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeFirstTimeUserDialogVideoViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose first time user-> dialog video view. Evid: 147.
 * Event description: Viewing welcome video lightbox (new user).

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeFirstTimeUserDialogVideoViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeFirstTimeUserDialogVideoView = function (params) {
    return { evid: 147, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emComposerRegionSettingChangedParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} region_subtype - name of the region sub type, same as 36:12
* @property {string} region_type - name of the region type, same as 36:12
* @property {string} setting_name - name of the setting that is being interacted with
* @property {string} setting_value - value of the setting that is being interacted with
* @property {string} settings_subtab - name of the settings subtab
* @property {string} settings_tab - name of the settings tab
* @property {GUID} uuid - null
**/
/**
 * Name: EM Composer - Region Setting Changed. Evid: 387.
 * Event description: Any of the EM Composer regions' settings changed.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * region_subtype - Type: string. Desc: name of the region sub type, same as 36:12
 *
 * region_type - Type: string. Desc: name of the region type, same as 36:12
 *
 * setting_name - Type: string. Desc: name of the setting that is being interacted with
 *
 * setting_value - Type: string. Desc: value of the setting that is being interacted with
 *
 * settings_subtab - Type: string. Desc: name of the settings subtab
 *
 * settings_tab - Type: string. Desc: name of the settings tab
 *
 * uuid - Type: guid.
 * @param {emComposerRegionSettingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emComposerRegionSettingChanged = function (params) {
    return { evid: 387, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeReturningUserSsmTipNextClickParams
* @property {string} context - null
* @property {string} current - current
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose returning user ssm-> tip next click. Evid: 144.
 * Event description: Clicking Next on tip (from the tips dialog)
returning user tip view opens when user returning first time and open  composer, dialog opens and clicking on "show".

 * context - Type: string.
 *
 * current - Type: string. Desc: current
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeReturningUserSsmTipNextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeReturningUserSsmTipNextClick = function (params) {
    return { evid: 144, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} notInUseGetSubscribersSubscribeSuccessParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: NOT IN USE - get subscribers -> subscribe success. Evid: 199.
 * Event description: when getting confirm from the server after clicking on "subscribe"
the client get the success from server and send the success event.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {notInUseGetSubscribersSubscribeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notInUseGetSubscribersSubscribeSuccess = function (params) {
    return { evid: 199, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeToggleClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} toggle_name - name of the setting being toggled
* @property {boolean} toggleState - toggle value (true, false)
* @property {GUID} uuid - null
**/
/**
 * Name: Shoutout Compose -> Toggle Click. Evid: 385.
 * Event description: Event for Toggling settings in shoutout composer.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * toggle_name - Type: string. Desc: name of the setting being toggled
 *
 * toggleState - Type: bool. Desc: toggle value (true, false)
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeToggleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeToggleClick = function (params) {
    return { evid: 385, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutResendModalCloseParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: Shoutout -> resend modal close. Evid: 29.
 * Event description: When user closes resend to non-openers modal by clicking on X or cancel.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutResendModalCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutResendModalClose = function (params) {
    return { evid: 29, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostPaymentEditPaymentClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost payment -> edit payment click. Evid: 190.
 * Event description: clicking on edit payment link - in facebook.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostPaymentEditPaymentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostPaymentEditPaymentClick = function (params) {
    return { evid: 190, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} senderDetailsModalCtaClickParams
* @property {string} context - null
* @property {string} cta_type - exit, cancel, save, confirm, change details, send again, got it
* @property {string} ml_translation_language - null
* @property {string} modal_type - add sender details, confirmation, success screen
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - the app which the feature was opened from
* @property {string} url - link for the CTA if it has one
* @property {GUID} uuid - uuid
**/
/**
 * Name: sender details - modal cta click. Evid: 234.
 * Event description: generic click on one of the modal CTAs.

 * context - Type: string.
 *
 * cta_type - Type: string. Desc: exit, cancel, save, confirm, change details, send again, got it
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: add sender details, confirmation, success screen
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: the app which the feature was opened from
 *
 * url - Type: string. Desc: link for the CTA if it has one
 *
 * uuid - Type: guid. Desc: uuid
 * @param {senderDetailsModalCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var senderDetailsModalCtaClick = function (params) {
    return { evid: 234, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsHeaderCtaClickParams
* @property {string} context - context
* @property {string} cta_type - "the name of the cta clicked on optional values: reuse"
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats-> header CTA click. Evid: 314.
 * Event description: when the user clicked on the header CTA (not upgrade!!!).

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: "the name of the cta clicked on optional values: reuse"
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page_status - Type: string. Desc: "the status of the page, if empty or not optional values: empty_state/full_data"
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsHeaderCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsHeaderCtaClick = function (params) {
    return { evid: 314, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardMoreTemplateClickParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} templatesList - templates list loaded to user in dashboard - for  impressions
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout dashboard -> more template click. Evid: 283.
 * Event description: in the dashboard - click on more template button to get to the template page.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * templatesList - Type: string. Desc: templates list loaded to user in dashboard - for  impressions
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutDashboardMoreTemplateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardMoreTemplateClick = function (params) {
    return { evid: 283, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersTabClickParams
* @property {string} context - null
* @property {string} description - description
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} tab_name - values: tab_name: settings, layout, design, emails, create
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers - tab click. Evid: 216.
 * Event description: click on one of the tab.

 * context - Type: string.
 *
 * description - Type: string. Desc: description
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * tab_name - Type: string. Desc: values: tab_name: settings, layout, design, emails, create
 *
 * uuid - Type: guid.
 * @param {getSubscribersTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersTabClick = function (params) {
    return { evid: 216, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutsModalViewParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {string} modal_type - the type of the modal (send, pause)
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout my shoutouts-> modal view. Evid: 296.
 * Event description: modal view in "my shoutouts" page.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: the type of the modal (send, pause)
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutMyShoutoutsModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutsModalView = function (params) {
    return { evid: 296, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutMyShoutoutDeleteClickParams
* @property {string} context - null
* @property {string} messages_type - draft/published
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout my shoutout -> delete click. Evid: 126.
 * Event description: in my shoutout , on one of the SO items click on delete to open delete dialog.

 * context - Type: string.
 *
 * messages_type - Type: string. Desc: draft/published
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutMyShoutoutDeleteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutMyShoutoutDeleteClick = function (params) {
    return { evid: 126, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeReturningUserSsmTipViewParams
* @property {string} context - null
* @property {string} current - current
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose returning user ssm-> tip view. Evid: 146.
 * Event description: Viewing tips  from the tips dialog
returning user tip view opens when user returning first time and open  composer, dialog opens and clicking on "show".

 * context - Type: string.
 *
 * current - Type: string. Desc: current
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeReturningUserSsmTipViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeReturningUserSsmTipView = function (params) {
    return { evid: 146, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutFooterUpgradeTooltipParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout -> footer upgrade tooltip. Evid: 46.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutFooterUpgradeTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutFooterUpgradeTooltip = function (params) {
    return { evid: 46, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} sieEditorPanelReturningBannerViewParams
* @property {string} context - null
* @property {GUID} esi - esi
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - shoutout editor panel
* @property {GUID} site_id - site_id for SO in Editor
* @property {number} ts - timespan from session start
* @property {string} type - generic/store
* @property {GUID} uuid - null
* @property {string} viewmode - view_mode
**/
/**
 * Name: SIE Editor panel returning banner-> View. Evid: 112.
 * Event description: user viewed banner CTA.

 * context - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: shoutout editor panel
 *
 * site_id - Type: guid. Desc: site_id for SO in Editor
 *
 * ts - Type: numeric. Desc: timespan from session start
 *
 * type - Type: string. Desc: generic/store
 *
 * uuid - Type: guid.
 *
 * viewmode - Type: string. Desc: view_mode
 * @param {sieEditorPanelReturningBannerViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sieEditorPanelReturningBannerView = function (params) {
    return { evid: 112, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostBudgetEditAgeClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost budget -> edit age click. Evid: 186.
 * Event description: changing targeted age group.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostBudgetEditAgeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostBudgetEditAgeClick = function (params) {
    return { evid: 186, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teBannerCtaClickParams
* @property {string} banner_type - name of the banner
* @property {string} clickType - null
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - metasite id
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - user id
**/
/**
 * Name: TE - banner cta click. Evid: 355.


 * banner_type - Type: string. Desc: name of the banner
 *
 * clickType - Type: string.
 *
 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: metasite id
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 * @param {teBannerCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teBannerCtaClick = function (params) {
    return { evid: 355, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSenderDetailsMissingModalCtaClickParams
* @property {string} context - context - TE
* @property {string} cta_type - name of button clicked
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - sender details missing modal cta click. Evid: 268.
 * Event description: click on one of the modal ctas.

 * context - Type: string. Desc: context - TE
 *
 * cta_type - Type: string. Desc: name of button clicked
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teSenderDetailsMissingModalCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSenderDetailsMissingModalCtaClick = function (params) {
    return { evid: 268, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerAssistancePopoverTasksListViewParams
* @property {string} context - context
* @property {string} default_task - the default task expended when opening the list
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {number} number_of_tasks - number of open tasks
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} tasks_list - json with all tasks types with rule id
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer - assistance popover tasks list view. Evid: 327.
 * Event description: the assistance popover is open.

 * context - Type: string. Desc: context
 *
 * default_task - Type: string. Desc: the default task expended when opening the list
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * number_of_tasks - Type: numeric. Desc: number of open tasks
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * tasks_list - Type: string. Desc: json with all tasks types with rule id
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerAssistancePopoverTasksListViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerAssistancePopoverTasksListView = function (params) {
    return { evid: 327, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPagePageViewParams
* @property {string} context - null
* @property {boolean} isRecipientsSelected - is_recipients_selected in contact page
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {boolean} only_active - true = only actives
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page -> page view. Evid: 30.


 * context - Type: string.
 *
 * isRecipientsSelected - Type: bool. Desc: is_recipients_selected in contact page
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * only_active - Type: bool. Desc: true = only actives
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPagePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPagePageView = function (params) {
    return { evid: 30, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutotAdLinkClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page_id - message identifier
* @property {GUID} uuid - null
**/
/**
 * Name: shoutot ad link-> click. Evid: 171.
 * Event description: when a UoU clicked on landing page ad.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: string. Desc: message identifier
 *
 * uuid - Type: guid.
 * @param {shoutotAdLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutotAdLinkClick = function (params) {
    return { evid: 171, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teFirstTimeGetStartedClickParams
* @property {string} context - context - TE
* @property {string} location - header/first-time
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - First time get started click. Evid: 239.
 * Event description: click o the get started button.

 * context - Type: string. Desc: context - TE
 *
 * location - Type: string. Desc: header/first-time
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teFirstTimeGetStartedClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teFirstTimeGetStartedClick = function (params) {
    return { evid: 239, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardCardLoadedWithStatsParams
* @property {string} context - null
* @property {GUID} message_id - message_id
* @property {string} message_type - published or sent
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {DateTime} published_on_date - timestamp on which message was published
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout dashboard -> card loaded with stats. Evid: 351.
 * Event description: when a card showing details of a sent message with stats is presented to the user. Note that this event will fire when we load the card, even if the stats themselves do not load..

 * context - Type: string.
 *
 * message_id - Type: guid. Desc: message_id
 *
 * message_type - Type: string. Desc: published or sent
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * published_on_date - Type: datetime. Desc: timestamp on which message was published
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {shoutoutDashboardCardLoadedWithStatsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardCardLoadedWithStats = function (params) {
    return { evid: 351, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPanelDropdownClickParams
* @property {string} clickType - expand / collapse
* @property {string} context - null
* @property {string} item - item for which the drop down menu was clicked (font, format, size etc.)
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - ascend package group
* @property {string} package_id - ascend package name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout compose - > dropdown click. Evid: 353.
 * Event description: When a drop down menu is expanded or collapsed.

 * clickType - Type: string. Desc: expand / collapse
 *
 * context - Type: string.
 *
 * item - Type: string. Desc: item for which the drop down menu was clicked (font, format, size etc.)
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: ascend package group
 *
 * package_id - Type: string. Desc: ascend package name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutPanelDropdownClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPanelDropdownClick = function (params) {
    return { evid: 353, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPanelPropertyErrorParams
* @property {string} context - context
* @property {string} error_type - invalid url, missing button title... (translation key)
* @property {string} item - item under each panel type (footer settings,inner background,outer backgrounf settings,text...), None
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} panel_type - add an item, style, background,
* @property {string} property - bold, underline, color.
* @property {string} property_value - Property Value
* @property {string} tab - Design, Style, Content, none
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout panel - > property error. Evid: 288.
 * Event description: after apply click, for each property send event if there is an error message.

 * context - Type: string. Desc: context
 *
 * error_type - Type: string. Desc: invalid url, missing button title... (translation key)
 *
 * item - Type: string. Desc: item under each panel type (footer settings,inner background,outer backgrounf settings,text...), None
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * panel_type - Type: string. Desc: add an item, style, background,
 *
 * property - Type: string. Desc: bold, underline, color.
 *
 * property_value - Type: string. Desc: Property Value
 *
 * tab - Type: string. Desc: Design, Style, Content, none
 *
 * uuid - Type: guid.
 * @param {shoutoutPanelPropertyErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPanelPropertyError = function (params) {
    return { evid: 288, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostSetUpProfilePermissionClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost set up -> profile permission click. Evid: 177.
 * Event description: click on grant profile permission.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostSetUpProfilePermissionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostSetUpProfilePermissionClick = function (params) {
    return { evid: 177, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutCampaignThreeDotsClickParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page - dashboard / my_campaigns / campaign_stats
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout - campaign three dots click. Evid: 366.
 * Event description: when user clicks on three dots either on campaign card or in stats page.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page - Type: string. Desc: dashboard / my_campaigns / campaign_stats
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutCampaignThreeDotsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutCampaignThreeDotsClick = function (params) {
    return { evid: 366, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} reuseTemplateModalShownParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: Reuse Template Modal Shown. Evid: 70.
 * Event description: Modal for reusing templates shown/viewed.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {reuseTemplateModalShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var reuseTemplateModalShown = function (params) {
    return { evid: 70, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} completePageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} page_id - the message id of the shoutOut
* @property {GUID} uuid - null
**/
/**
 * Name: complete page view. Evid: 97.
 * Event description: user views the complete page.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: guid. Desc: the message id of the shoutOut
 *
 * uuid - Type: guid.
 * @param {completePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var completePageView = function (params) {
    return { evid: 97, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSendPageSendTestEmailClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout send page-> send test email click. Evid: 162.
 * Event description: Clicking on Test Email button.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSendPageSendTestEmailClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSendPageSendTestEmailClick = function (params) {
    return { evid: 162, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsNextPageParams
* @property {string} context - null
* @property {number} count - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout contacts -> next page. Evid: 24.


 * context - Type: string.
 *
 * count - Type: numeric.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutContactsNextPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsNextPage = function (params) {
    return { evid: 24, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} senderDetailsModalViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {string} modal_type - add sender details, confirmation, success screen
* @property {GUID} msid - msid
* @property {string} origin - source of open the modal - 'transactional emails dashboard', 'transactional email composer'
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - the app which the feature was opened from
* @property {string} sender_details_status - verified/unverified
* @property {GUID} uuid - uuid
**/
/**
 * Name: sender details - modal view. Evid: 232.
 * Event description: generic modal view for the sender details feature.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: add sender details, confirmation, success screen
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: source of open the modal - 'transactional emails dashboard', 'transactional email composer'
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: the app which the feature was opened from
 *
 * sender_details_status - Type: string. Desc: verified/unverified
 *
 * uuid - Type: guid. Desc: uuid
 * @param {senderDetailsModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var senderDetailsModalView = function (params) {
    return { evid: 232, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emPremiumProductUpgradeComparePlansClickParams
* @property {string} button_location - Where the button is in the page
* @property {string} button_name - upgrade/compare_plans/CTA_upgrade
* @property {string} context - context
* @property {string} cycle_name - name of the current user EM premium cycle
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - Page on which the event fires
* @property {string} package_group - EM package group
* @property {string} package_id - EM package ID
* @property {GUID} uuid - null
**/
/**
 * Name: EM Premium Product - Upgrade/Compare Plans Click. Evid: 377.
 * Event description: Event for upgrade button click.

 * button_location - Type: string. Desc: Where the button is in the page
 *
 * button_name - Type: string. Desc: upgrade/compare_plans/CTA_upgrade
 *
 * context - Type: string. Desc: context
 *
 * cycle_name - Type: string. Desc: name of the current user EM premium cycle
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: Page on which the event fires
 *
 * package_group - Type: string. Desc: EM package group
 *
 * package_id - Type: string. Desc: EM package ID
 *
 * uuid - Type: guid.
 * @param {emPremiumProductUpgradeComparePlansClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emPremiumProductUpgradeComparePlansClick = function (params) {
    return { evid: 377, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teAutoSaveSuccessParams
* @property {GUID} action_id - action_id
* @property {string} components_data - Json with all components data and number of componet
* @property {string} context - context
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {number} number_of_placeholders - number_of_placeholders
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} rule_id - rule_id
* @property {string} subject - the subject in the message
* @property {string} template_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE AUTO - save success. Evid: 274.
 * Event description: success event for save new automation shoutout.

 * action_id - Type: guid. Desc: action_id
 *
 * components_data - Type: string. Desc: Json with all components data and number of componet
 *
 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * number_of_placeholders - Type: numeric. Desc: number_of_placeholders
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * rule_id - Type: guid. Desc: rule_id
 *
 * subject - Type: string. Desc: the subject in the message
 *
 * template_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teAutoSaveSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teAutoSaveSuccess = function (params) {
    return { evid: 274, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardModalViewParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {string} modal_type - the type of the modal (send, pause)
* @property {GUID} msid - msid
* @property {string} origin - if relevant (scheduler cta/e dots)
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page - dashboard,my campaigns
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout -> modal view - generic. Evid: 298.
 * Event description: modal view in "dashboard"/my campaigns  page.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: the type of the modal (send, pause)
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: if relevant (scheduler cta/e dots)
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page - Type: string. Desc: dashboard,my campaigns
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutDashboardModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardModalView = function (params) {
    return { evid: 298, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardLearnMoreClickParams
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_id
* @property {Url} url - article url link
* @property {string} type - widget source
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout dashboard-> learn more click. Evid: 209.
 * Event description: click on learn more form a widget.

 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_id
 *
 * url - Type: url. Desc: article url link
 *
 * type - Type: string. Desc: widget source
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutDashboardLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardLearnMoreClick = function (params) {
    return { evid: 209, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutAscendPopoverViewParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page - page, in which the popover was viewed
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout - ascend popover view. Evid: 364.
 * Event description: When user hovers over Ascend upgrade button and sees Ascend popover.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page - Type: string. Desc: page, in which the popover was viewed
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutAscendPopoverViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutAscendPopoverView = function (params) {
    return { evid: 364, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutWidgetBlankViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout widget-> blank view. Evid: 81.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutWidgetBlankViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutWidgetBlankView = function (params) {
    return { evid: 81, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emailsButtonClickParams
* @property {string} button_name - name of the button
* @property {string} context - context
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} origin - where the button was clicked
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {GUID} uuid - uuid
**/
/**
 * Name: Emails - button click. Evid: 386.
 * Event description: Generic button click event.

 * button_name - Type: string. Desc: name of the button
 *
 * context - Type: string. Desc: context
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: where the button was clicked
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {emailsButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emailsButtonClick = function (params) {
    return { evid: 386, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeItemRemovedParams
* @property {string} context - null
* @property {boolean} is_title - is title region
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - NA
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> item removed. Evid: 107.
 * Event description: item removed.

 * context - Type: string.
 *
 * is_title - Type: bool. Desc: is title region
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: NA
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeItemRemovedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeItemRemoved = function (params) {
    return { evid: 107, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutReachingQuotaTooltipParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} page_name - null
* @property {string} quota_type - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout -> reaching quota tooltip. Evid: 45.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_name - Type: string.
 *
 * quota_type - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutReachingQuotaTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutReachingQuotaTooltip = function (params) {
    return { evid: 45, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teTextComponentDynamicVariableModalViewParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - text-region/subject
* @property {GUID} uuid - null
**/
/**
 * Name: composer - text component dynamic variable modal view. Evid: 242.
 * Event description: dynamic variable modal view open.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: text-region/subject
 *
 * uuid - Type: guid.
 * @param {teTextComponentDynamicVariableModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teTextComponentDynamicVariableModalView = function (params) {
    return { evid: 242, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSubjectLineLearnMoreClickParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - subject line learn more click. Evid: 248.
 * Event description: action that finish and save the subject line.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teSubjectLineLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSubjectLineLearnMoreClick = function (params) {
    return { evid: 248, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersEmailsSendBeautifulNewsletterParams
* @property {string} context - null
* @property {string} description - description
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers emails - send beautiful newsletter. Evid: 223.
 * Event description: Clicking on ShoutOut 'Start Now' button.

 * context - Type: string.
 *
 * description - Type: string. Desc: description
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {getSubscribersEmailsSendBeautifulNewsletterParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersEmailsSendBeautifulNewsletter = function (params) {
    return { evid: 223, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsStatClickParams
* @property {string} context - context
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} stat_name - "the name of the stat the user clicked on optional values: DELIVERED/OPENED/CLICKED/UNSUBSCRIBED/BOUNCED/SPAM COMPAINTS"
* @property {string} tab_shown - "the name of the tab that the user views optional values: email stats/ email recipients/ social stats"
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats-> stat click. Evid: 315.
 * Event description: when the user clicked on a stat in any of the tabs.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * stat_name - Type: string. Desc: "the name of the stat the user clicked on optional values: DELIVERED/OPENED/CLICKED/UNSUBSCRIBED/BOUNCED/SPAM COMPAINTS"
 *
 * tab_shown - Type: string. Desc: "the name of the tab that the user views optional values: email stats/ email recipients/ social stats"
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsStatClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsStatClick = function (params) {
    return { evid: 315, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersBeatAfterLoadedParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {number} second_of_beat - 2,4
* @property {GUID} uuid - null
* @property {GUID} vsi - visitor session ID
**/
/**
 * Name: get subscribers -> beat after loaded. Evid: 303.
 * Event description: event triggered when the app loaded -after 0, 2 and 4 seconds . its debug event for app loading. after "0" suppose to be equal to 19/643 the app is loaded..

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * second_of_beat - Type: numeric. Desc: 2,4
 *
 * uuid - Type: guid.
 *
 * vsi - Type: guid. Desc: visitor session ID
 * @param {getSubscribersBeatAfterLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersBeatAfterLoaded = function (params) {
    return { evid: 303, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teResetTemplateClickParams
* @property {string} context - context (TE/APeS...)
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {string} template_id - template id
* @property {GUID} uuid - null
**/
/**
 * Name: TE - reset template click. Evid: 344.
 * Event description: reset template click.

 * context - Type: string. Desc: context (TE/APeS...)
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * template_id - Type: string. Desc: template id
 *
 * uuid - Type: guid.
 * @param {teResetTemplateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teResetTemplateClick = function (params) {
    return { evid: 344, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutUpgradePromotionViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid -  msid
* @property {string} package_group -  Free/Basic/Business/Pro
* @property {string} package_id -  vendor product id
* @property {string} page_name -  page user is in
* @property {string} promotion_type -  type of promotion
* @property {string} quota_type -  quota type (messages/emails)
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout -> upgrade promotion view. Evid: 25.
 * Event description: promotion view shown (tooltip/modal/others) UPGRADE_PROMOTION_VIEW.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc:  msid
 *
 * package_group - Type: string. Desc:  Free/Basic/Business/Pro
 *
 * package_id - Type: string. Desc:  vendor product id
 *
 * page_name - Type: string. Desc:  page user is in
 *
 * promotion_type - Type: string. Desc:  type of promotion
 *
 * quota_type - Type: string. Desc:  quota type (messages/emails)
 *
 * uuid - Type: guid.
 * @param {shoutoutUpgradePromotionViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutUpgradePromotionView = function (params) {
    return { evid: 25, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutEditorPanelOpenParams
* @property {string} context - null
* @property {string} editor_working_mode - editor_working_mode
* @property {GUID} esi - esi
* @property {boolean} is_first - is first time user opened the panel
* @property {number} ts - timespan from session start
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} notification - gsNotTouched/gsNotIntalled/none
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - shoutout editor panel
* @property {GUID} site_id - site_id for SO in Editor
* @property {string} type - GetSubscribers/Email
* @property {GUID} uuid - null
* @property {string} viewmode - view_mode
**/
/**
 * Name: shoutout editor panel-> open. Evid: 89.
 * Event description: shoutout editor panel-> open.

 * context - Type: string.
 *
 * editor_working_mode - Type: string. Desc: editor_working_mode
 *
 * esi - Type: guid. Desc: esi
 *
 * is_first - Type: bool. Desc: is first time user opened the panel
 *
 * ts - Type: numeric. Desc: timespan from session start
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * notification - Type: string. Desc: gsNotTouched/gsNotIntalled/none
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: shoutout editor panel
 *
 * site_id - Type: guid. Desc: site_id for SO in Editor
 *
 * type - Type: string. Desc: GetSubscribers/Email
 *
 * uuid - Type: guid.
 *
 * viewmode - Type: string. Desc: view_mode
 * @param {shoutoutEditorPanelOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutEditorPanelOpen = function (params) {
    return { evid: 89, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} composerAssistanceExpendTaskParams
* @property {string} context - context
* @property {GUID} message_id - if exists
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} origin - user, auto
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} rule - unique rule id
* @property {string} task_type - text, button, link, social....
* @property {string} template_id - template_id
* @property {GUID} uuid - null
**/
/**
 * Name: composer - assistance expend task. Evid: 328.
 * Event description: in the assistance popover click on one of the tasks to expend it.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: if exists
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: user, auto
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * rule - Type: string. Desc: unique rule id
 *
 * task_type - Type: string. Desc: text, button, link, social....
 *
 * template_id - Type: string. Desc: template_id
 *
 * uuid - Type: guid.
 * @param {composerAssistanceExpendTaskParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var composerAssistanceExpendTask = function (params) {
    return { evid: 328, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposeOpenDynamicVariableClickParams
* @property {string} context - application context
* @property {string} cta_source - where the user click to open the variable modal (add dynamic variable button OR existing variable)
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose- open dynamic variable click. Evid: 345.
 * Event description: when a user click on a button that will open the modal of adding a dynamic variable.

 * context - Type: string. Desc: application context
 *
 * cta_source - Type: string. Desc: where the user click to open the variable modal (add dynamic variable button OR existing variable)
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutComposeOpenDynamicVariableClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposeOpenDynamicVariableClick = function (params) {
    return { evid: 345, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostBudgetChangeBudgetClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - increase / decease amount
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost budget -> change budget click. Evid: 185.
 * Event description: changing budget amount.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: increase / decease amount
 *
 * uuid - Type: guid.
 * @param {fbBoostBudgetChangeBudgetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostBudgetChangeBudgetClick = function (params) {
    return { evid: 185, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} fbBoostCongratsGoToAdClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: FB boost congrats-> go to ad click. Evid: 195.
 * Event description: clicking on go to ad.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {fbBoostCongratsGoToAdClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fbBoostCongratsGoToAdClick = function (params) {
    return { evid: 195, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardNewShoutoutClickedParams
* @property {string} context - null
* @property {string} editor_working_mode - (esi, ts, viewmode) default editor field
* @property {GUID} esi - esi for SO in Editor
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} site_id - site_id for SO in Editor
* @property {number} ts - ts for SO in Editor
* @property {GUID} uuid - null
* @property {string} viewmode - viewmode for SO in Editor
**/
/**
 * Name: shoutout dashboard->new shoutout clicked. Evid: 77.
 * Event description: new shoutout clicked.

 * context - Type: string.
 *
 * editor_working_mode - Type: string. Desc: (esi, ts, viewmode) default editor field
 *
 * esi - Type: guid. Desc: esi for SO in Editor
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * site_id - Type: guid. Desc: site_id for SO in Editor
 *
 * ts - Type: numeric. Desc: ts for SO in Editor
 *
 * uuid - Type: guid.
 *
 * viewmode - Type: string. Desc: viewmode for SO in Editor
 * @param {shoutoutDashboardNewShoutoutClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardNewShoutoutClicked = function (params) {
    return { evid: 77, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teMessageDetailsModalCopyParams
* @property {string} context - context - TE
* @property {string} email_id - email_id
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {string} modal_type - published success,code snippets
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - email_id,script,contacts-script,registered-script
* @property {GUID} uuid - null
**/
/**
 * Name: TE - message details modal copy. Evid: 254.
 * Event description: click on copy script or email id.

 * context - Type: string. Desc: context - TE
 *
 * email_id - Type: string. Desc: email_id
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: published success,code snippets
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: email_id,script,contacts-script,registered-script
 *
 * uuid - Type: guid.
 * @param {teMessageDetailsModalCopyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teMessageDetailsModalCopy = function (params) {
    return { evid: 254, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutSidebarTemplatesClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout sidebar -> Templates click. Evid: 99.
 * Event description: Click on contacts.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutSidebarTemplatesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutSidebarTemplatesClick = function (params) {
    return { evid: 99, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutHtmlViewNotificationModalParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout html -> view notification modal. Evid: 280.
 * Event description: view the notification modal for old email.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutHtmlViewNotificationModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutHtmlViewNotificationModal = function (params) {
    return { evid: 280, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsShareModalViewParams
* @property {string} context - context
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package_group
* @property {string} package_id - package_name
* @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats-> share modal view. Evid: 318.
 * Event description: when the user gets the modal to share his campaign in social media or by link.

 * context - Type: string. Desc: context
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package_group
 *
 * package_id - Type: string. Desc: package_name
 *
 * page_status - Type: string. Desc: "the status of the page, if empty or not optional values: empty_state/full_data"
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsShareModalViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsShareModalView = function (params) {
    return { evid: 318, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutTemplatesPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - new so/templates
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} page_id - na
* @property {string} templatesList - templates list loaded to user - for  impressions
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout templates -> page view. Evid: 58.
 * Event description: templates page view.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: new so/templates
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * page_id - Type: guid. Desc: na
 *
 * templatesList - Type: string. Desc: templates list loaded to user - for  impressions
 *
 * uuid - Type: guid.
 * @param {shoutoutTemplatesPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutTemplatesPageView = function (params) {
    return { evid: 58, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} getSubscribersPopupRemoveOldPopupParams
* @property {string} context - null
* @property {string} description - description
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: get subscribers popup - remove old popup. Evid: 221.
 * Event description: When user has OLD popup - click on remove button.

 * context - Type: string.
 *
 * description - Type: string. Desc: description
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {getSubscribersPopupRemoveOldPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getSubscribersPopupRemoveOldPopup = function (params) {
    return { evid: 221, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teTextComponentDynamicVariableModalLearnMoreClickParams
* @property {string} context - context - TE
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - text-region/subject
* @property {GUID} uuid - null
**/
/**
 * Name: TE - text component dynamic variable modal learn more click. Evid: 246.
 * Event description: close the dynamic variable.

 * context - Type: string. Desc: context - TE
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: text-region/subject
 *
 * uuid - Type: guid.
 * @param {teTextComponentDynamicVariableModalLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teTextComponentDynamicVariableModalLearnMoreClick = function (params) {
    return { evid: 246, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardWidgetItemClickParams
* @property {string} campaign_source - web/mobile
* @property {string} context - null
* @property {GUID} message_id - if exists
* @property {string} message_type - published, draft, schedule, etc...
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} name - widget  name
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
* @property {string} value - action value
**/
/**
 * Name: shoutout dashboard -> widget item click. Evid: 125.
 * Event description: in the shoutout dashboard (dashboard in the side bar) click on any widget.

 * campaign_source - Type: string. Desc: web/mobile
 *
 * context - Type: string.
 *
 * message_id - Type: guid. Desc: if exists
 *
 * message_type - Type: string. Desc: published, draft, schedule, etc...
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * name - Type: string. Desc: widget  name
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 *
 * value - Type: string. Desc: action value
 * @param {shoutoutDashboardWidgetItemClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardWidgetItemClick = function (params) {
    return { evid: 125, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutDashboardPageViewParams
* @property {string} context - null
* @property {number} load_time - milisecond
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} templatesList - templates list loaded to user - for  impressions
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout dashboard ->  page view. Evid: 130.
 * Event description: event fired when opening the shoutout dashboard view , from any origin in the app.

 * context - Type: string.
 *
 * load_time - Type: numeric. Desc: milisecond
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * templatesList - Type: string. Desc: templates list loaded to user - for  impressions
 *
 * uuid - Type: guid.
 * @param {shoutoutDashboardPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutDashboardPageView = function (params) {
    return { evid: 130, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emMessageShownParams
* @property {string} context - context
* @property {string} message_name - name of the message/banner/CTA/pop-up
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: EM - Message Shown. Evid: 40.
 * Event description: Any message/banner/CTA/pop-up related to EM shown to the user.

 * context - Type: string. Desc: context
 *
 * message_name - Type: string. Desc: name of the message/banner/CTA/pop-up
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {emMessageShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emMessageShown = function (params) {
    return { evid: 40, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutStatsReportsCtaParams
* @property {string} context - context
* @property {string} cta_type - what was clicked (expand / report name)
* @property {GUID} message_id - message id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - package group
* @property {string} package_id - package name
* @property {GUID} uuid - uuid
**/
/**
 * Name: shoutout stats-> reports cta. Evid: 359.
 * Event description: When user clicks on link in email marketing stats page, which leads to analytics reports.

 * context - Type: string. Desc: context
 *
 * cta_type - Type: string. Desc: what was clicked (expand / report name)
 *
 * message_id - Type: guid. Desc: message id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string. Desc: package group
 *
 * package_id - Type: string. Desc: package name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {shoutoutStatsReportsCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutStatsReportsCta = function (params) {
    return { evid: 359, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} sosaDialogChooseParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} selection - selected path
* @property {GUID} uuid - null
**/
/**
 * Name: sosa dialog -> choose. Evid: 169.
 * Event description: Choosing value in the existing Wix users dialog.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * selection - Type: string. Desc: selected path
 *
 * uuid - Type: guid.
 * @param {sosaDialogChooseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sosaDialogChoose = function (params) {
    return { evid: 169, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} senderDetailsConfirmationSuccessParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - the app which the feature was opened from
* @property {boolean} success - true - code is good, false - code is wrong
* @property {GUID} uuid - uuid
**/
/**
 * Name: sender details  - confirmation success. Evid: 237.
 * Event description: after click on the confirm cta in the last modal  - this event been fired.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: the app which the feature was opened from
 *
 * success - Type: bool. Desc: true - code is good, false - code is wrong
 *
 * uuid - Type: guid. Desc: uuid
 * @param {senderDetailsConfirmationSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var senderDetailsConfirmationSuccess = function (params) {
    return { evid: 237, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutPackagePickerMonthlyExpandButtonParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: Shoutout package picker -> monthly expand button. Evid: 19.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutPackagePickerMonthlyExpandButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutPackagePickerMonthlyExpandButton = function (params) {
    return { evid: 19, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutComposePanelClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} type - panel chosen value
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout compose -> panel click. Evid: 139.
 * Event description: in the in the shoutout compose page click on the side menu.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * type - Type: string. Desc: panel chosen value
 *
 * uuid - Type: guid.
 * @param {shoutoutComposePanelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutComposePanelClick = function (params) {
    return { evid: 139, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutEmailVerificationExplanationExitParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout email verification-> explanation exit. Evid: 154.
 * Event description: click to Exiting verification lightbox.

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutoutEmailVerificationExplanationExitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutEmailVerificationExplanationExit = function (params) {
    return { evid: 154, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutout123StepsHeaderDashboardClickParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout 1-2-3 steps header -> dashboard click. Evid: 120.
 * Event description: in the shoutout 1-2-3 steps page header  click on the "dashboard".

 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {shoutout123StepsHeaderDashboardClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutout123StepsHeaderDashboardClick = function (params) {
    return { evid: 120, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} emOpenPackagePickerParams
* @property {string} button_location - where was the button that lead to PP (source comes from 36:377)
* @property {string} button_name - button name that lead to PP (source comes from 36:377)
* @property {string} context - null
* @property {string} em_premium_status - current EM premium package + cycle
* @property {boolean} is_sale - Flag that defines if the users PP is with a sale
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {string} origin - where the page was opened from (source comes from 36:377)
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: EM - Open Package Picker. Evid: 379.
 * Event description: EM Standalone Premium Plans Package Picked Opened (page shown).

 * button_location - Type: string. Desc: where was the button that lead to PP (source comes from 36:377)
 *
 * button_name - Type: string. Desc: button name that lead to PP (source comes from 36:377)
 *
 * context - Type: string.
 *
 * em_premium_status - Type: string. Desc: current EM premium package + cycle
 *
 * is_sale - Type: bool. Desc: Flag that defines if the users PP is with a sale
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: where the page was opened from (source comes from 36:377)
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {emOpenPackagePickerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emOpenPackagePicker = function (params) {
    return { evid: 379, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} senderDetailsModalInfoHoverMessageViewParams
* @property {string} context - null
* @property {string} cta_type - from name, reply to mail
* @property {string} ml_translation_language - null
* @property {string} modal_type - add sender details, confirmation, success screen
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {string} referral_info - the app which the feature was opened from
* @property {GUID} uuid - uuid
**/
/**
 * Name: sender details  - modal info hover message view. Evid: 233.
 * Event description: over on info sign in the modal, a message pops out.

 * context - Type: string.
 *
 * cta_type - Type: string. Desc: from name, reply to mail
 *
 * ml_translation_language - Type: string.
 *
 * modal_type - Type: string. Desc: add sender details, confirmation, success screen
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * referral_info - Type: string. Desc: the app which the feature was opened from
 *
 * uuid - Type: guid. Desc: uuid
 * @param {senderDetailsModalInfoHoverMessageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var senderDetailsModalInfoHoverMessageView = function (params) {
    return { evid: 233, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} teSenderDetailsMissingModalCloseParams
* @property {string} context - context - TE
* @property {GUID} message_id - message_id
* @property {string} ml_translation_language - null
* @property {GUID} msid - msid
* @property {string} package_group - null
* @property {string} package_id - null
* @property {GUID} uuid - null
**/
/**
 * Name: TE - sender details missing modal close. Evid: 267.
 * Event description: click on the X to close.

 * context - Type: string. Desc: context - TE
 *
 * message_id - Type: guid. Desc: message_id
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * uuid - Type: guid.
 * @param {teSenderDetailsMissingModalCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teSenderDetailsMissingModalClose = function (params) {
    return { evid: 267, src: 36, endpoint: 'shout', params: params };
};
/**
* @typedef {Object} shoutoutContactsPageViewParams
* @property {string} context - null
* @property {string} ml_translation_language - null
* @property {GUID} msid - null
* @property {boolean} only_active - true = only actives
* @property {string} package_group - null
* @property {string} package_id - null
* @property {number} total_contacts - not in use
* @property {GUID} uuid - null
**/
/**
 * Name: shoutout contacts -> page view. Evid: 20.


 * context - Type: string.
 *
 * ml_translation_language - Type: string.
 *
 * msid - Type: guid.
 *
 * only_active - Type: bool. Desc: true = only actives
 *
 * package_group - Type: string.
 *
 * package_id - Type: string.
 *
 * total_contacts - Type: numeric. Desc: not in use
 *
 * uuid - Type: guid.
 * @param {shoutoutContactsPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shoutoutContactsPageView = function (params) {
    return { evid: 20, src: 36, endpoint: 'shout', params: params };
};
//# sourceMappingURL=index.js.map